/**
 * GENERATED FILE — DO NOT EDIT.
 * Source: packages/marketplace-contracts/openapi.json
 * Source content hash (sha256): 5daf5caffa1c17cff317b6850c27e75ba4822324ba399a60186c52a71122cd2d
 * Generated by: orval 7.21.0
 * Regenerate: pnpm --filter @cotality/marketplace-contracts orval
 * Hash semantics: sha256 of openapi.json bytes — merge-invariant (squash/rebase safe).
 */

/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Cotality Marketplace API
 * HTTP API for the Cotality Marketplace. Authoring is concentrated in `packages/marketplace-contracts` — Zod schemas there feed both runtime validation in `marketplace-api` and this OpenAPI document. Hand-edits to `openapi.json` are overwritten on the next build.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminCollectContributions202,
  AdminCollectContributions403,
  AdminCollectContributions503,
  AdminHubOrphans200,
  AdminHubOrphans403,
  AdminHubQueue200,
  AdminHubQueue403,
  AdminHubQueueForceAutoComplete200,
  AdminHubQueueForceAutoComplete400,
  AdminHubQueueForceAutoComplete403,
  AdminHubQueueForceAutoComplete404,
  AdminHubQueueForceAutoComplete502,
  AdminHubQueueForceAutoComplete503,
  AdminSyncJobPluginResults200,
  AdminSyncJobPluginResults403,
  AdminSyncJobPluginResultsParams,
  AdminSyncSource202,
  AdminSyncSource403,
  AdminSyncSource404,
  AdminSyncSource502,
  AdminSyncSource503,
  AdminSyncSweep202,
  AdminSyncSweep403,
  AdminSyncSweep409,
  AdminSyncSweepJobs200,
  AdminSyncSweepJobs403,
  AdminSyncSweepJobsParams,
  AdminSyncSweeps200,
  AdminSyncSweeps400,
  AdminSyncSweeps403,
  AdminSyncSweepsExport400,
  AdminSyncSweepsExport403,
  AdminSyncSweepsExportParams,
  AdminSyncSweepsParams,
  AdminTeamMembershipSync202,
  AdminTeamMembershipSync403,
  AdminTeamMembershipSync404,
  AdminTeamMembershipSync409,
  AdminTeamMembershipSyncBody,
  AdminTeamMembershipSyncRuns200,
  AdminTeamMembershipSyncRuns400,
  AdminTeamMembershipSyncRuns403,
  AdminTeamMembershipSyncRunsParams,
  AdminTeamReprovision202,
  AdminTeamReprovision403,
  AdminTeamReprovision404,
  AdminTeamReprovision409,
  AdminTeamReprovisionAll202,
  AdminTeamReprovisionAll403,
  AdminTeamReprovisionAll409,
  AdminTeamReprovisionRunResults200,
  AdminTeamReprovisionRunResults403,
  AdminTeamReprovisionRunResultsParams,
  AdminTeamReprovisionRuns200,
  AdminTeamReprovisionRuns400,
  AdminTeamReprovisionRuns403,
  AdminTeamReprovisionRunsExport400,
  AdminTeamReprovisionRunsExport403,
  AdminTeamReprovisionRunsExportParams,
  AdminTeamReprovisionRunsParams,
  AuditExport400,
  AuditExport403,
  AuditExportParams,
  AuditList200,
  AuditList400,
  AuditListParams,
  AuthMe200,
  AuthMe401,
  BannerGet200,
  BannerGet403,
  BannerUpdate200,
  BannerUpdate400,
  BannerUpdate403,
  BannerUpdateBody,
  CategoriesList200,
  CategoriesList400,
  CategoriesList403,
  CategoriesListParams,
  FlagsDelete403,
  FlagsDelete404,
  FlagsExport400,
  FlagsExport403,
  FlagsExportParams,
  FlagsList200,
  FlagsList400,
  FlagsList403,
  FlagsListParams,
  FlagsUpdate200,
  FlagsUpdate400,
  FlagsUpdate403,
  FlagsUpdate404,
  FlagsUpdateBody,
  HealthLive200,
  HealthReady200,
  HealthReady503,
  ManifestRoot200,
  ManifestTeam200,
  ManifestTeam404,
  MetricsContributionsByTeam200,
  MetricsContributionsByTeam400,
  MetricsContributionsByTeam403,
  MetricsContributionsByTeamParams,
  MetricsContributionsTimeseries200,
  MetricsContributionsTimeseries400,
  MetricsContributionsTimeseries403,
  MetricsContributionsTimeseriesParams,
  MetricsExport400,
  MetricsExport403,
  MetricsExportParams,
  MetricsInstalls200,
  MetricsInstalls400,
  MetricsInstalls403,
  MetricsInstallsParams,
  MetricsPluginsTimeseries200,
  MetricsPluginsTimeseries400,
  MetricsPluginsTimeseries403,
  MetricsPluginsTimeseriesParams,
  MetricsSummary200,
  MetricsSummary403,
  MetricsTeamActivity200,
  MetricsTeamActivity400,
  MetricsTeamActivity403,
  MetricsTeamActivityParams,
  MetricsUsersTimeseries200,
  MetricsUsersTimeseries400,
  MetricsUsersTimeseries403,
  MetricsUsersTimeseriesParams,
  PluginsDeprecate200,
  PluginsDeprecate403,
  PluginsDeprecate404,
  PluginsDeprecate409,
  PluginsDeprecateBody,
  PluginsExport400,
  PluginsExport403,
  PluginsExportParams,
  PluginsGet200,
  PluginsGet400,
  PluginsGet403,
  PluginsGet404,
  PluginsGetByName200,
  PluginsGetByName400,
  PluginsGetByName403,
  PluginsGetByName404,
  PluginsList200,
  PluginsList400,
  PluginsList403,
  PluginsListParams,
  PluginsUnmarkDeprecated200,
  PluginsUnmarkDeprecated403,
  PluginsUnmarkDeprecated404,
  PluginsUnmarkDeprecatedBody,
  PluginsUnyank200,
  PluginsUnyank403,
  PluginsUnyank404,
  PluginsUnyankBody,
  PluginsUpdate200,
  PluginsUpdate400,
  PluginsUpdate403,
  PluginsUpdate404,
  PluginsUpdateBody,
  PluginsYank200,
  PluginsYank400,
  PluginsYank403,
  PluginsYank404,
  PluginsYankBody,
  RolesExport400,
  RolesExport403,
  RolesExportParams,
  RolesList200,
  RolesList400,
  RolesList403,
  RolesListParams,
  RolesPermissions200,
  RolesPermissions403,
  RolesUpdate200,
  RolesUpdate400,
  RolesUpdate403,
  RolesUpdate404,
  RolesUpdateBody,
  SourcesExport400,
  SourcesExport403,
  SourcesExportParams,
  SourcesGet200,
  SourcesGet403,
  SourcesGet404,
  SourcesList200,
  SourcesList400,
  SourcesList403,
  SourcesListParams,
  SourcesReactivate200,
  SourcesReactivate403,
  SourcesReactivate404,
  SourcesReactivate409,
  SourcesReactivate502,
  SourcesRefreshTemplate200,
  SourcesRefreshTemplate403,
  SourcesRefreshTemplate404,
  SourcesRefreshTemplate409,
  SourcesRefreshTemplate500,
  SourcesRegisterHook200,
  SourcesRegisterHook403,
  SourcesRegisterHook404,
  SourcesRotateSecret200,
  SourcesRotateSecret202,
  SourcesRotateSecret400,
  SourcesRotateSecret403,
  SourcesRotateSecret404,
  SourcesRotateSecret409,
  SourcesRotateSecret502,
  SourcesRotateSecretBody,
  SourcesSync202,
  SourcesSync400,
  SourcesSync403,
  SourcesSync404,
  SourcesSync409,
  SourcesSync502,
  SourcesSyncBody,
  SourcesSyncJobs200,
  SourcesSyncJobs400,
  SourcesSyncJobs403,
  SourcesSyncJobs404,
  SourcesSyncJobsParams,
  StatusGet200,
  SubmissionsApprove200,
  SubmissionsApprove403,
  SubmissionsApprove404,
  SubmissionsApprove409,
  SubmissionsApproveBody,
  SubmissionsCreate202,
  SubmissionsCreate400,
  SubmissionsCreate403,
  SubmissionsCreate413,
  SubmissionsCreate415,
  SubmissionsCreate429,
  SubmissionsCreate502,
  SubmissionsCreateBody,
  SubmissionsExport400,
  SubmissionsExport403,
  SubmissionsExportParams,
  SubmissionsGet200,
  SubmissionsGet403,
  SubmissionsGet404,
  SubmissionsList200,
  SubmissionsList400,
  SubmissionsListParams,
  SubmissionsReject200,
  SubmissionsReject400,
  SubmissionsReject403,
  SubmissionsReject404,
  SubmissionsReject409,
  SubmissionsRejectBody,
  SubmissionsRequeue200,
  SubmissionsRequeue403,
  SubmissionsRequeue404,
  SubmissionsRequeue409,
  SubmissionsRequeue422,
  TeamsAddAdmin200,
  TeamsAddAdmin201,
  TeamsAddAdmin400,
  TeamsAddAdmin403,
  TeamsAddAdmin404,
  TeamsAddAdminBody,
  TeamsAddMember200,
  TeamsAddMember201,
  TeamsAddMember400,
  TeamsAddMember403,
  TeamsAddMember404,
  TeamsAddMemberBody,
  TeamsAddReviewer200,
  TeamsAddReviewer201,
  TeamsAddReviewer400,
  TeamsAddReviewer403,
  TeamsAddReviewer404,
  TeamsAddReviewerBody,
  TeamsCreate202,
  TeamsCreate400,
  TeamsCreate403,
  TeamsCreate404,
  TeamsCreate409,
  TeamsCreate502,
  TeamsCreateBody,
  TeamsDelete403,
  TeamsDelete404,
  TeamsExport400,
  TeamsExport403,
  TeamsExportParams,
  TeamsGet200,
  TeamsGet400,
  TeamsGet403,
  TeamsGet404,
  TeamsGetByName200,
  TeamsGetByName400,
  TeamsGetByName403,
  TeamsGetByName404,
  TeamsList200,
  TeamsList400,
  TeamsList403,
  TeamsListAdmins200,
  TeamsListAdmins400,
  TeamsListAdmins403,
  TeamsListAdmins404,
  TeamsListAdminsParams,
  TeamsListMembers200,
  TeamsListMembers400,
  TeamsListMembers403,
  TeamsListMembers404,
  TeamsListMembersParams,
  TeamsListParams,
  TeamsListReviewers200,
  TeamsListReviewers400,
  TeamsListReviewers403,
  TeamsListReviewers404,
  TeamsListReviewersParams,
  TeamsRemoveAdmin403,
  TeamsRemoveAdmin404,
  TeamsRemoveAdmin409,
  TeamsRemoveMember403,
  TeamsRemoveMember404,
  TeamsRemoveReviewer403,
  TeamsRemoveReviewer404,
  TeamsUpdate200,
  TeamsUpdate400,
  TeamsUpdate403,
  TeamsUpdate404,
  TeamsUpdateBody,
  UsersExport400,
  UsersExport403,
  UsersExportParams,
  UsersGet200,
  UsersGet400,
  UsersGet403,
  UsersGet404,
  UsersGetTeamRoles200,
  UsersGetTeamRoles400,
  UsersGetTeamRoles403,
  UsersGetTeamRoles404,
  UsersList200,
  UsersList400,
  UsersList401,
  UsersList403,
  UsersListParams,
  UsersOverrideAdoIdentity200,
  UsersOverrideAdoIdentity400,
  UsersOverrideAdoIdentity403,
  UsersOverrideAdoIdentity404,
  UsersOverrideAdoIdentity409,
  UsersOverrideAdoIdentity422,
  UsersOverrideAdoIdentity503,
  UsersOverrideAdoIdentityBody,
  UsersResolveAdoIdentity200,
  UsersResolveAdoIdentity400,
  UsersResolveAdoIdentity403,
  UsersResolveAdoIdentity404,
  UsersResolveAdoIdentity503,
  UsersUpdateRoles200,
  UsersUpdateRoles400,
  UsersUpdateRoles403,
  UsersUpdateRoles409,
  UsersUpdateRolesBody,
  UsersUpdateTrusted200,
  UsersUpdateTrusted400,
  UsersUpdateTrusted403,
  UsersUpdateTrusted404,
  UsersUpdateTrustedBody,
  WebhooksAdoPush200,
  WebhooksAdoPush400,
  WebhooksAdoPush401,
  WebhooksAdoPush404,
  WebhooksAdoPush503,
  WebhooksAdoPushBody
} from './schemas';

import { mutator } from './mutator';




/**
 * Public marketplace index consumed by Claude Code. The response is a bare manifest object — the success/data envelope is intentionally bypassed for compatibility with external clients. Cached for 60 s; honours `If-None-Match`.
 * @summary Root marketplace manifest
 */
export const manifestRoot = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<ManifestRoot200>(
      {url: `/api/.well-known/marketplace.json`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getManifestRootQueryKey = () => {
    return [
    `/api/.well-known/marketplace.json`
    ] as const;
    }

    
export const getManifestRootQueryOptions = <TData = Awaited<ReturnType<typeof manifestRoot>>, TError = void>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof manifestRoot>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getManifestRootQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof manifestRoot>>> = ({ signal }) => manifestRoot(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof manifestRoot>>, TError, TData> & { queryKey: QueryKey }
}

export type ManifestRootQueryResult = NonNullable<Awaited<ReturnType<typeof manifestRoot>>>
export type ManifestRootQueryError = void


/**
 * @summary Root marketplace manifest
 */

export function useManifestRoot<TData = Awaited<ReturnType<typeof manifestRoot>>, TError = void>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof manifestRoot>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getManifestRootQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Team-scoped marketplace manifest. Same envelope-bypass / caching rules as the root manifest. Returns 404 when the team slug is unknown or has no active plugins.
 * @summary Per-team marketplace manifest
 */
export const manifestTeam = (
    teamName: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<ManifestTeam200>(
      {url: `/api/.well-known/marketplace.${teamName}.json`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getManifestTeamQueryKey = (teamName?: string,) => {
    return [
    `/api/.well-known/marketplace.${teamName}.json`
    ] as const;
    }

    
export const getManifestTeamQueryOptions = <TData = Awaited<ReturnType<typeof manifestTeam>>, TError = void | ManifestTeam404>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof manifestTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getManifestTeamQueryKey(teamName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof manifestTeam>>> = ({ signal }) => manifestTeam(teamName, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof manifestTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ManifestTeamQueryResult = NonNullable<Awaited<ReturnType<typeof manifestTeam>>>
export type ManifestTeamQueryError = void | ManifestTeam404


/**
 * @summary Per-team marketplace manifest
 */

export function useManifestTeam<TData = Awaited<ReturnType<typeof manifestTeam>>, TError = void | ManifestTeam404>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof manifestTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getManifestTeamQueryOptions(teamName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns plugins whose sync-repo Hub PR is open but not yet merged (`hub_pr_url IS NOT NULL AND hub_listed_at IS NULL`). Operators use this to track PRs awaiting marketplace-admin review against `Cotality.Marketplace.Hub`. Read-only; no audit row, no mutation. Default sort is newest-first by `created_at`. See ADR-0003 + Task 12 of the Hub bootstrap plan.
 * @summary List plugins awaiting Hub PR merge
 */
export const adminHubQueue = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminHubQueue200>(
      {url: `/api/admin/hub-queue`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminHubQueueQueryKey = () => {
    return [
    `/api/admin/hub-queue`
    ] as const;
    }

    
export const getAdminHubQueueQueryOptions = <TData = Awaited<ReturnType<typeof adminHubQueue>>, TError = AdminHubQueue403>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminHubQueue>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminHubQueueQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminHubQueue>>> = ({ signal }) => adminHubQueue(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminHubQueue>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminHubQueueQueryResult = NonNullable<Awaited<ReturnType<typeof adminHubQueue>>>
export type AdminHubQueueQueryError = AdminHubQueue403


/**
 * @summary List plugins awaiting Hub PR merge
 */

export function useAdminHubQueue<TData = Awaited<ReturnType<typeof adminHubQueue>>, TError = AdminHubQueue403>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminHubQueue>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminHubQueueQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Operator escape hatch (Task 10, ADR-0003) that turns the manual `PATCH` used to unblock four stalled Hub PRs on 2026-07-29 into a supported action: re-issues `AdoClient.setPullRequestAutoComplete` (ADO's PR *create* endpoint silently discards `completionOptions`/`autoCompleteSetBy`) for exactly the cases the automation deliberately does not handle on its own — `hub-pr-auto-complete` is off but this PR should still merge, or the reconcile-sync self-heal sweep is itself failing. Keyed by `pluginId`, never a raw ADO PR id — resolved through `plugins.hub_pr_url` so an operator can only target a rollup PR the marketplace itself opened, never a human's PR. Writes a `plugin.hub_pr_force_auto_complete` audit row AFTER the ADO PATCH succeeds. 404 when the plugin is missing, soft-deleted, or has no open Hub PR; 400 when `hub_pr_url` has no parseable PR id; 502 when ADO rejects the PATCH; 503 when the route's ADO client / Hub repo id are not configured.
 * @summary Force auto-complete on a plugin's Hub PR (admin)
 */
export const adminHubQueueForceAutoComplete = (
    pluginId: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminHubQueueForceAutoComplete200>(
      {url: `/api/admin/hub-queue/${pluginId}/force-auto-complete`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getAdminHubQueueForceAutoCompleteMutationOptions = <TError = AdminHubQueueForceAutoComplete400 | AdminHubQueueForceAutoComplete403 | AdminHubQueueForceAutoComplete404 | AdminHubQueueForceAutoComplete502 | AdminHubQueueForceAutoComplete503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminHubQueueForceAutoComplete>>, TError,{pluginId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminHubQueueForceAutoComplete>>, TError,{pluginId: string}, TContext> => {

const mutationKey = ['adminHubQueueForceAutoComplete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminHubQueueForceAutoComplete>>, {pluginId: string}> = (props) => {
          const {pluginId} = props ?? {};

          return  adminHubQueueForceAutoComplete(pluginId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminHubQueueForceAutoCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof adminHubQueueForceAutoComplete>>>
    
    export type AdminHubQueueForceAutoCompleteMutationError = AdminHubQueueForceAutoComplete400 | AdminHubQueueForceAutoComplete403 | AdminHubQueueForceAutoComplete404 | AdminHubQueueForceAutoComplete502 | AdminHubQueueForceAutoComplete503

    /**
 * @summary Force auto-complete on a plugin's Hub PR (admin)
 */
export const useAdminHubQueueForceAutoComplete = <TError = AdminHubQueueForceAutoComplete400 | AdminHubQueueForceAutoComplete403 | AdminHubQueueForceAutoComplete404 | AdminHubQueueForceAutoComplete502 | AdminHubQueueForceAutoComplete503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminHubQueueForceAutoComplete>>, TError,{pluginId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminHubQueueForceAutoComplete>>,
        TError,
        {pluginId: string},
        TContext
      > => {

      const mutationOptions = getAdminHubQueueForceAutoCompleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns the persisted `hub_orphan_listings`: names present in the Hub `marketplace.json` with no matching catalog row (e.g. a plugin the sync validator skipped on a secret-scan finding, never upserted). Distinct from the hub-queue (pending PRs): an orphan is listed in the Hub but missing from our catalog. Upserted by the reconcile mirror pass, cleared when the catalog row appears or the name leaves the Hub. Sorted oldest-first by `first_seen_at` so the longest-orphaned rows surface at the top. Read-only; no audit row, no mutation.
 * @summary List Hub-listed plugins missing from the catalog (orphans)
 */
export const adminHubOrphans = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminHubOrphans200>(
      {url: `/api/admin/hub/orphans`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminHubOrphansQueryKey = () => {
    return [
    `/api/admin/hub/orphans`
    ] as const;
    }

    
export const getAdminHubOrphansQueryOptions = <TData = Awaited<ReturnType<typeof adminHubOrphans>>, TError = AdminHubOrphans403>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminHubOrphans>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminHubOrphansQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminHubOrphans>>> = ({ signal }) => adminHubOrphans(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminHubOrphans>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminHubOrphansQueryResult = NonNullable<Awaited<ReturnType<typeof adminHubOrphans>>>
export type AdminHubOrphansQueryError = AdminHubOrphans403


/**
 * @summary List Hub-listed plugins missing from the catalog (orphans)
 */

export function useAdminHubOrphans<TData = Awaited<ReturnType<typeof adminHubOrphans>>, TError = AdminHubOrphans403>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminHubOrphans>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminHubOrphansQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Enqueues an immediate `collect-contributions` run instead of waiting for the 01:00 UTC schedule — the operator surface for rollout step 2 (first backfill) and for re-collecting after an ADO outage. Writes an `admin.collect_contributions` audit row in its own transaction, which commits BEFORE the enqueue rather than alongside it: a BullMQ `add()` cannot be rolled back with Postgres, so the audit row records that an operator triggered a run, and a subsequent enqueue failure surfaces as a 5xx instead of erasing the audit trail. Idempotent by construction: the collector upserts on (date_utc, source_id, author_email) and only advances a source watermark on success.
 * @summary Collect contributions now (admin)
 */
export const adminCollectContributions = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminCollectContributions202>(
      {url: `/api/admin/sync/contributions`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getAdminCollectContributionsMutationOptions = <TError = AdminCollectContributions403 | AdminCollectContributions503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCollectContributions>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminCollectContributions>>, TError,void, TContext> => {

const mutationKey = ['adminCollectContributions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminCollectContributions>>, void> = () => {
          

          return  adminCollectContributions()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminCollectContributionsMutationResult = NonNullable<Awaited<ReturnType<typeof adminCollectContributions>>>
    
    export type AdminCollectContributionsMutationError = AdminCollectContributions403 | AdminCollectContributions503

    /**
 * @summary Collect contributions now (admin)
 */
export const useAdminCollectContributions = <TError = AdminCollectContributions403 | AdminCollectContributions503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminCollectContributions>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminCollectContributions>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAdminCollectContributionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * The `sync_job_plugin_results` rows for one `sync_jobs` row — the structured, queryable per-plugin detail (outcome + redacted validator findings + actionable message) behind the lossy 200-char `sync_jobs.error`. Lets operators see exactly which plugins synced, were skipped on a secret-scan finding, collided, or had bad JSON. Oldest first (stable `created_at`, then `id`). Read-only; no audit row. Spec 2026-06-15 §3.
 * @summary List per-plugin results for one sync job
 */
export const adminSyncJobPluginResults = (
    id: string,
    params?: AdminSyncJobPluginResultsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminSyncJobPluginResults200>(
      {url: `/api/admin/sync/jobs/${id}/plugin-results`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminSyncJobPluginResultsQueryKey = (id?: string,
    params?: AdminSyncJobPluginResultsParams,) => {
    return [
    `/api/admin/sync/jobs/${id}/plugin-results`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminSyncJobPluginResultsQueryOptions = <TData = Awaited<ReturnType<typeof adminSyncJobPluginResults>>, TError = AdminSyncJobPluginResults403>(id: string,
    params?: AdminSyncJobPluginResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSyncJobPluginResults>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSyncJobPluginResultsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSyncJobPluginResults>>> = ({ signal }) => adminSyncJobPluginResults(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSyncJobPluginResults>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminSyncJobPluginResultsQueryResult = NonNullable<Awaited<ReturnType<typeof adminSyncJobPluginResults>>>
export type AdminSyncJobPluginResultsQueryError = AdminSyncJobPluginResults403


/**
 * @summary List per-plugin results for one sync job
 */

export function useAdminSyncJobPluginResults<TData = Awaited<ReturnType<typeof adminSyncJobPluginResults>>, TError = AdminSyncJobPluginResults403>(
 id: string,
    params?: AdminSyncJobPluginResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSyncJobPluginResults>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminSyncJobPluginResultsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Admin counterpart to `POST /api/sources/:id/sync` — gated by `admin:sync` (not team-scoped) so a marketplace admin can force-resync any source cross-team. Resolves the source repo's branch HEAD and enqueues a `sync-repo` job for it (`sweep_id` null), writing an `admin.sync_source` audit row. 404 when the source is missing or not active; 502 when ADO returns no HEAD; 503 when the force-resync deps are not configured. Spec 2026-06-15 §3.
 * @summary Force re-sync a single source (admin)
 */
export const adminSyncSource = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminSyncSource202>(
      {url: `/api/admin/sync/sources/${id}`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getAdminSyncSourceMutationOptions = <TError = AdminSyncSource403 | AdminSyncSource404 | AdminSyncSource502 | AdminSyncSource503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSyncSource>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminSyncSource>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminSyncSource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSyncSource>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminSyncSource(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminSyncSourceMutationResult = NonNullable<Awaited<ReturnType<typeof adminSyncSource>>>
    
    export type AdminSyncSourceMutationError = AdminSyncSource403 | AdminSyncSource404 | AdminSyncSource502 | AdminSyncSource503

    /**
 * @summary Force re-sync a single source (admin)
 */
export const useAdminSyncSource = <TError = AdminSyncSource403 | AdminSyncSource404 | AdminSyncSource502 | AdminSyncSource503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSyncSource>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminSyncSource>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdminSyncSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Opens a manual reconcile sweep: reclaims any crash-stuck `running` row older than 20 min, inserts a fresh `running` sweep row (the partial unique index is the atomic guard), enqueues a `reconcile-sync` job carrying the sweep id, and writes an `admin.sync_sweep` audit row. A concurrent trigger while a fresh sweep runs returns 409 `SWEEP_ALREADY_RUNNING`. Spec 2026-06-15 §3 / §7.
 * @summary Trigger a manual reconcile sweep
 */
export const adminSyncSweep = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminSyncSweep202>(
      {url: `/api/admin/sync/sweep`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getAdminSyncSweepMutationOptions = <TError = AdminSyncSweep403 | AdminSyncSweep409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSyncSweep>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminSyncSweep>>, TError,void, TContext> => {

const mutationKey = ['adminSyncSweep'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSyncSweep>>, void> = () => {
          

          return  adminSyncSweep()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminSyncSweepMutationResult = NonNullable<Awaited<ReturnType<typeof adminSyncSweep>>>
    
    export type AdminSyncSweepMutationError = AdminSyncSweep403 | AdminSyncSweep409

    /**
 * @summary Trigger a manual reconcile sweep
 */
export const useAdminSyncSweep = <TError = AdminSyncSweep403 | AdminSyncSweep409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSyncSweep>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminSyncSweep>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAdminSyncSweepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Paginated reconcile-sweep history, newest first. The admin dashboard landing summary reuses this with `pageSize=1`. Supports `sort` (signed comma-joined field: status, trigger, startedAt, finishedAt) and `status` (comma-joined filter: running, succeeded, failed). Read-only; no audit row. Spec 2026-06-15 §3.
 * @summary List reconcile sweep history
 */
export const adminSyncSweeps = (
    params?: AdminSyncSweepsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminSyncSweeps200>(
      {url: `/api/admin/sync/sweeps`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminSyncSweepsQueryKey = (params?: AdminSyncSweepsParams,) => {
    return [
    `/api/admin/sync/sweeps`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminSyncSweepsQueryOptions = <TData = Awaited<ReturnType<typeof adminSyncSweeps>>, TError = AdminSyncSweeps400 | AdminSyncSweeps403>(params?: AdminSyncSweepsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweeps>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSyncSweepsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSyncSweeps>>> = ({ signal }) => adminSyncSweeps(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweeps>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminSyncSweepsQueryResult = NonNullable<Awaited<ReturnType<typeof adminSyncSweeps>>>
export type AdminSyncSweepsQueryError = AdminSyncSweeps400 | AdminSyncSweeps403


/**
 * @summary List reconcile sweep history
 */

export function useAdminSyncSweeps<TData = Awaited<ReturnType<typeof adminSyncSweeps>>, TError = AdminSyncSweeps400 | AdminSyncSweeps403>(
 params?: AdminSyncSweepsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweeps>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminSyncSweepsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all sweeps matching the filter + sort params as a text/csv attachment. Same filter surface as admin_sync_sweeps but without pagination. Capped at 50 000 rows server-side.
 * @summary Export reconcile sweep history as CSV
 */
export const adminSyncSweepsExport = (
    params?: AdminSyncSweepsExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/admin/sync/sweeps/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminSyncSweepsExportQueryKey = (params?: AdminSyncSweepsExportParams,) => {
    return [
    `/api/admin/sync/sweeps/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminSyncSweepsExportQueryOptions = <TData = Awaited<ReturnType<typeof adminSyncSweepsExport>>, TError = AdminSyncSweepsExport400 | AdminSyncSweepsExport403>(params?: AdminSyncSweepsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweepsExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSyncSweepsExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSyncSweepsExport>>> = ({ signal }) => adminSyncSweepsExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweepsExport>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminSyncSweepsExportQueryResult = NonNullable<Awaited<ReturnType<typeof adminSyncSweepsExport>>>
export type AdminSyncSweepsExportQueryError = AdminSyncSweepsExport400 | AdminSyncSweepsExport403


/**
 * @summary Export reconcile sweep history as CSV
 */

export function useAdminSyncSweepsExport<TData = Awaited<ReturnType<typeof adminSyncSweepsExport>>, TError = AdminSyncSweepsExport400 | AdminSyncSweepsExport403>(
 params?: AdminSyncSweepsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweepsExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminSyncSweepsExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * The `sync_jobs` rows fanned out by one reconcile sweep (drill-down), newest first, joined to the source display name. Read-only; no audit row. Spec 2026-06-15 §3.
 * @summary List the sync jobs produced by one sweep
 */
export const adminSyncSweepJobs = (
    id: string,
    params?: AdminSyncSweepJobsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminSyncSweepJobs200>(
      {url: `/api/admin/sync/sweeps/${id}/jobs`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminSyncSweepJobsQueryKey = (id?: string,
    params?: AdminSyncSweepJobsParams,) => {
    return [
    `/api/admin/sync/sweeps/${id}/jobs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminSyncSweepJobsQueryOptions = <TData = Awaited<ReturnType<typeof adminSyncSweepJobs>>, TError = AdminSyncSweepJobs403>(id: string,
    params?: AdminSyncSweepJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweepJobs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminSyncSweepJobsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSyncSweepJobs>>> = ({ signal }) => adminSyncSweepJobs(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweepJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminSyncSweepJobsQueryResult = NonNullable<Awaited<ReturnType<typeof adminSyncSweepJobs>>>
export type AdminSyncSweepJobsQueryError = AdminSyncSweepJobs403


/**
 * @summary List the sync jobs produced by one sweep
 */

export function useAdminSyncSweepJobs<TData = Awaited<ReturnType<typeof adminSyncSweepJobs>>, TError = AdminSyncSweepJobs403>(
 id: string,
    params?: AdminSyncSweepJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminSyncSweepJobs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminSyncSweepJobsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Opens a membership-sync run and enqueues the sync job. Reconciles marketplace team membership against the ADO Teams roster: adopts members added directly in ADO, deactivates members removed there, and pushes back any marketplace-only members ADO is missing. Scoped to a single team when `teamId` is given, otherwise runs across every provisioned team. `dryRun: true` computes and persists counts without applying changes. 404 when `teamId` is given but not found. 409 when a run is already in progress.
 * @summary Sync team memberships from ADO (adopt, deactivate, and push; ADO-authoritative)
 */
export const adminTeamMembershipSync = (
    adminTeamMembershipSyncBody: AdminTeamMembershipSyncBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminTeamMembershipSync202>(
      {url: `/api/admin/teams/membership-sync`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminTeamMembershipSyncBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getAdminTeamMembershipSyncMutationOptions = <TError = AdminTeamMembershipSync403 | AdminTeamMembershipSync404 | AdminTeamMembershipSync409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTeamMembershipSync>>, TError,{data: AdminTeamMembershipSyncBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminTeamMembershipSync>>, TError,{data: AdminTeamMembershipSyncBody}, TContext> => {

const mutationKey = ['adminTeamMembershipSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTeamMembershipSync>>, {data: AdminTeamMembershipSyncBody}> = (props) => {
          const {data} = props ?? {};

          return  adminTeamMembershipSync(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminTeamMembershipSyncMutationResult = NonNullable<Awaited<ReturnType<typeof adminTeamMembershipSync>>>
    export type AdminTeamMembershipSyncMutationBody = AdminTeamMembershipSyncBody
    export type AdminTeamMembershipSyncMutationError = AdminTeamMembershipSync403 | AdminTeamMembershipSync404 | AdminTeamMembershipSync409

    /**
 * @summary Sync team memberships from ADO (adopt, deactivate, and push; ADO-authoritative)
 */
export const useAdminTeamMembershipSync = <TError = AdminTeamMembershipSync403 | AdminTeamMembershipSync404 | AdminTeamMembershipSync409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTeamMembershipSync>>, TError,{data: AdminTeamMembershipSyncBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminTeamMembershipSync>>,
        TError,
        {data: AdminTeamMembershipSyncBody},
        TContext
      > => {

      const mutationOptions = getAdminTeamMembershipSyncMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Paginated membership-sync run history, newest first. Supports `sort` (signed comma-joined field: status, trigger, startedAt) and `status` (comma-joined filter: running, succeeded, failed). Read-only; no audit row.
 * @summary List membership-sync run history
 */
export const adminTeamMembershipSyncRuns = (
    params?: AdminTeamMembershipSyncRunsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminTeamMembershipSyncRuns200>(
      {url: `/api/admin/teams/membership-sync-runs`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminTeamMembershipSyncRunsQueryKey = (params?: AdminTeamMembershipSyncRunsParams,) => {
    return [
    `/api/admin/teams/membership-sync-runs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminTeamMembershipSyncRunsQueryOptions = <TData = Awaited<ReturnType<typeof adminTeamMembershipSyncRuns>>, TError = AdminTeamMembershipSyncRuns400 | AdminTeamMembershipSyncRuns403>(params?: AdminTeamMembershipSyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminTeamMembershipSyncRuns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTeamMembershipSyncRunsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTeamMembershipSyncRuns>>> = ({ signal }) => adminTeamMembershipSyncRuns(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTeamMembershipSyncRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminTeamMembershipSyncRunsQueryResult = NonNullable<Awaited<ReturnType<typeof adminTeamMembershipSyncRuns>>>
export type AdminTeamMembershipSyncRunsQueryError = AdminTeamMembershipSyncRuns400 | AdminTeamMembershipSyncRuns403


/**
 * @summary List membership-sync run history
 */

export function useAdminTeamMembershipSyncRuns<TData = Awaited<ReturnType<typeof adminTeamMembershipSyncRuns>>, TError = AdminTeamMembershipSyncRuns400 | AdminTeamMembershipSyncRuns403>(
 params?: AdminTeamMembershipSyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminTeamMembershipSyncRuns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminTeamMembershipSyncRunsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Opens a bulk re-provision run across every non-deleted provisioned team (ado_repo_id not a pending placeholder) and enqueues a `reprovision-team` job. Same ensure-only semantics as the single-team route. 409 when a run is already in progress.
 * @summary Re-provision all provisioned teams (ensure-only)
 */
export const adminTeamReprovisionAll = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminTeamReprovisionAll202>(
      {url: `/api/admin/teams/reprovision-all`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getAdminTeamReprovisionAllMutationOptions = <TError = AdminTeamReprovisionAll403 | AdminTeamReprovisionAll409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTeamReprovisionAll>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminTeamReprovisionAll>>, TError,void, TContext> => {

const mutationKey = ['adminTeamReprovisionAll'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTeamReprovisionAll>>, void> = () => {
          

          return  adminTeamReprovisionAll()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminTeamReprovisionAllMutationResult = NonNullable<Awaited<ReturnType<typeof adminTeamReprovisionAll>>>
    
    export type AdminTeamReprovisionAllMutationError = AdminTeamReprovisionAll403 | AdminTeamReprovisionAll409

    /**
 * @summary Re-provision all provisioned teams (ensure-only)
 */
export const useAdminTeamReprovisionAll = <TError = AdminTeamReprovisionAll403 | AdminTeamReprovisionAll409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTeamReprovisionAll>>, TError,void, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminTeamReprovisionAll>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAdminTeamReprovisionAllMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Paginated re-provision run history, newest first. Supports `sort` (signed comma-joined field: status, trigger, startedAt) and `status` (comma-joined filter: running, succeeded, failed). Read-only; no audit row.
 * @summary List team re-provision run history
 */
export const adminTeamReprovisionRuns = (
    params?: AdminTeamReprovisionRunsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminTeamReprovisionRuns200>(
      {url: `/api/admin/teams/reprovision-runs`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminTeamReprovisionRunsQueryKey = (params?: AdminTeamReprovisionRunsParams,) => {
    return [
    `/api/admin/teams/reprovision-runs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminTeamReprovisionRunsQueryOptions = <TData = Awaited<ReturnType<typeof adminTeamReprovisionRuns>>, TError = AdminTeamReprovisionRuns400 | AdminTeamReprovisionRuns403>(params?: AdminTeamReprovisionRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRuns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTeamReprovisionRunsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTeamReprovisionRuns>>> = ({ signal }) => adminTeamReprovisionRuns(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminTeamReprovisionRunsQueryResult = NonNullable<Awaited<ReturnType<typeof adminTeamReprovisionRuns>>>
export type AdminTeamReprovisionRunsQueryError = AdminTeamReprovisionRuns400 | AdminTeamReprovisionRuns403


/**
 * @summary List team re-provision run history
 */

export function useAdminTeamReprovisionRuns<TData = Awaited<ReturnType<typeof adminTeamReprovisionRuns>>, TError = AdminTeamReprovisionRuns400 | AdminTeamReprovisionRuns403>(
 params?: AdminTeamReprovisionRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRuns>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminTeamReprovisionRunsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all reprovision runs matching the filter + sort params as a text/csv attachment. Same filter surface as admin_team_reprovision_runs but without pagination. Capped at 50 000 rows server-side.
 * @summary Export team re-provision run history as CSV
 */
export const adminTeamReprovisionRunsExport = (
    params?: AdminTeamReprovisionRunsExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/admin/teams/reprovision-runs/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminTeamReprovisionRunsExportQueryKey = (params?: AdminTeamReprovisionRunsExportParams,) => {
    return [
    `/api/admin/teams/reprovision-runs/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminTeamReprovisionRunsExportQueryOptions = <TData = Awaited<ReturnType<typeof adminTeamReprovisionRunsExport>>, TError = AdminTeamReprovisionRunsExport400 | AdminTeamReprovisionRunsExport403>(params?: AdminTeamReprovisionRunsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRunsExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTeamReprovisionRunsExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTeamReprovisionRunsExport>>> = ({ signal }) => adminTeamReprovisionRunsExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRunsExport>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminTeamReprovisionRunsExportQueryResult = NonNullable<Awaited<ReturnType<typeof adminTeamReprovisionRunsExport>>>
export type AdminTeamReprovisionRunsExportQueryError = AdminTeamReprovisionRunsExport400 | AdminTeamReprovisionRunsExport403


/**
 * @summary Export team re-provision run history as CSV
 */

export function useAdminTeamReprovisionRunsExport<TData = Awaited<ReturnType<typeof adminTeamReprovisionRunsExport>>, TError = AdminTeamReprovisionRunsExport400 | AdminTeamReprovisionRunsExport403>(
 params?: AdminTeamReprovisionRunsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRunsExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminTeamReprovisionRunsExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * The per-team outcomes within one re-provision run (drill-down), newest first. Read-only; no audit row.
 * @summary List per-team results for one re-provision run
 */
export const adminTeamReprovisionRunResults = (
    id: string,
    params?: AdminTeamReprovisionRunResultsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminTeamReprovisionRunResults200>(
      {url: `/api/admin/teams/reprovision-runs/${id}/results`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAdminTeamReprovisionRunResultsQueryKey = (id?: string,
    params?: AdminTeamReprovisionRunResultsParams,) => {
    return [
    `/api/admin/teams/reprovision-runs/${id}/results`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminTeamReprovisionRunResultsQueryOptions = <TData = Awaited<ReturnType<typeof adminTeamReprovisionRunResults>>, TError = AdminTeamReprovisionRunResults403>(id: string,
    params?: AdminTeamReprovisionRunResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRunResults>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTeamReprovisionRunResultsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTeamReprovisionRunResults>>> = ({ signal }) => adminTeamReprovisionRunResults(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRunResults>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminTeamReprovisionRunResultsQueryResult = NonNullable<Awaited<ReturnType<typeof adminTeamReprovisionRunResults>>>
export type AdminTeamReprovisionRunResultsQueryError = AdminTeamReprovisionRunResults403


/**
 * @summary List per-team results for one re-provision run
 */

export function useAdminTeamReprovisionRunResults<TData = Awaited<ReturnType<typeof adminTeamReprovisionRunResults>>, TError = AdminTeamReprovisionRunResults403>(
 id: string,
    params?: AdminTeamReprovisionRunResultsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminTeamReprovisionRunResults>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminTeamReprovisionRunResultsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Opens a single-team re-provision run and enqueues a `reprovision-team` job. Idempotent, ensure-only: adopt/create the ADO Admins+Reviewers Teams, persist their ids, seed Admins from the current roster (add-only), ensure the main branch policy (create-if-absent), ensure the repo ACL. Never removes members or downgrades settings. 409 when a run is already in progress.
 * @summary Re-provision a single team (ensure-only)
 */
export const adminTeamReprovision = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<AdminTeamReprovision202>(
      {url: `/api/admin/teams/${id}/reprovision`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getAdminTeamReprovisionMutationOptions = <TError = AdminTeamReprovision403 | AdminTeamReprovision404 | AdminTeamReprovision409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTeamReprovision>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminTeamReprovision>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminTeamReprovision'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTeamReprovision>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminTeamReprovision(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminTeamReprovisionMutationResult = NonNullable<Awaited<ReturnType<typeof adminTeamReprovision>>>
    
    export type AdminTeamReprovisionMutationError = AdminTeamReprovision403 | AdminTeamReprovision404 | AdminTeamReprovision409

    /**
 * @summary Re-provision a single team (ensure-only)
 */
export const useAdminTeamReprovision = <TError = AdminTeamReprovision403 | AdminTeamReprovision404 | AdminTeamReprovision409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTeamReprovision>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminTeamReprovision>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdminTeamReprovisionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Paginated, filter-able audit feed. Auth-only at the route layer, then row-level scoped in the service: callers WITH `audit:view` see all rows, everyone else is auto-scoped to their own `actor_id` (never a 403). Filters AND together; `search` substring-matches across action / resource_id / actor email. The `audit:view` permission widens scope; it is not required to call the route.
 * @summary Read the audit log
 */
export const auditList = (
    params?: AuditListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<AuditList200>(
      {url: `/api/audit`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAuditListQueryKey = (params?: AuditListParams,) => {
    return [
    `/api/audit`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAuditListQueryOptions = <TData = Awaited<ReturnType<typeof auditList>>, TError = AuditList400>(params?: AuditListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof auditList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditList>>> = ({ signal }) => auditList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditList>>, TError, TData> & { queryKey: QueryKey }
}

export type AuditListQueryResult = NonNullable<Awaited<ReturnType<typeof auditList>>>
export type AuditListQueryError = AuditList400


/**
 * @summary Read the audit log
 */

export function useAuditList<TData = Awaited<ReturnType<typeof auditList>>, TError = AuditList400>(
 params?: AuditListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof auditList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuditListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all audit log rows matching the filter + sort params as a `text/csv` attachment. Same filter surface as `audit_list` (action, actorId, resourceType, resourceId, search, sort) but without pagination. Capped at 50 000 rows server-side. Row-level scoping applies identically to the list route: non-admins only export rows where `actor_id = principalUserId`.
 * @summary Export audit log as CSV
 */
export const auditExport = (
    params?: AuditExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/audit/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAuditExportQueryKey = (params?: AuditExportParams,) => {
    return [
    `/api/audit/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAuditExportQueryOptions = <TData = Awaited<ReturnType<typeof auditExport>>, TError = AuditExport400 | AuditExport403>(params?: AuditExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof auditExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditExport>>> = ({ signal }) => auditExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditExport>>, TError, TData> & { queryKey: QueryKey }
}

export type AuditExportQueryResult = NonNullable<Awaited<ReturnType<typeof auditExport>>>
export type AuditExportQueryError = AuditExport400 | AuditExport403


/**
 * @summary Export audit log as CSV
 */

export function useAuditExport<TData = Awaited<ReturnType<typeof auditExport>>, TError = AuditExport400 | AuditExport403>(
 params?: AuditExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof auditExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuditExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns the authenticated principal expanded with role + permission rows resolved from DB. The UI calls this once on boot to learn what gates it has cleared. No `requirePermissions` — any signed-in user can call.
 * @summary Current principal + effective permissions
 */
export const authMe = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<AuthMe200>(
      {url: `/api/auth/me`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getAuthMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }

    
export const getAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof authMe>>, TError = AuthMe401>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authMe>>> = ({ signal }) => authMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof authMe>>>
export type AuthMeQueryError = AuthMe401


/**
 * @summary Current principal + effective permissions
 */

export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = AuthMe401>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Admin read of the full banner state (incl. saved content while disabled), used to prefill the Banner admin form. The PUBLIC render shape rides GET /api/status (banner field). Gated banner:update.
 * @summary Get the editable sidebar banner state
 */
export const bannerGet = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<BannerGet200>(
      {url: `/api/banner`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getBannerGetQueryKey = () => {
    return [
    `/api/banner`
    ] as const;
    }

    
export const getBannerGetQueryOptions = <TData = Awaited<ReturnType<typeof bannerGet>>, TError = BannerGet403>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof bannerGet>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBannerGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof bannerGet>>> = ({ signal }) => bannerGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof bannerGet>>, TError, TData> & { queryKey: QueryKey }
}

export type BannerGetQueryResult = NonNullable<Awaited<ReturnType<typeof bannerGet>>>
export type BannerGetQueryError = BannerGet403


/**
 * @summary Get the editable sidebar banner state
 */

export function useBannerGet<TData = Awaited<ReturnType<typeof bannerGet>>, TError = BannerGet403>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof bannerGet>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getBannerGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Sets the sidebar-banner flag enabled state + content. Cannot enable an empty-title banner. Emits a banner.updated audit row. Gated banner:update.
 * @summary Update the sidebar banner
 */
export const bannerUpdate = (
    bannerUpdateBody: BannerUpdateBody,
 ) => {
      
      
      return mutator<BannerUpdate200>(
      {url: `/api/banner`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bannerUpdateBody
    },
      );
    }
  


export const getBannerUpdateMutationOptions = <TError = BannerUpdate400 | BannerUpdate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bannerUpdate>>, TError,{data: BannerUpdateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bannerUpdate>>, TError,{data: BannerUpdateBody}, TContext> => {

const mutationKey = ['bannerUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bannerUpdate>>, {data: BannerUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  bannerUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BannerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof bannerUpdate>>>
    export type BannerUpdateMutationBody = BannerUpdateBody
    export type BannerUpdateMutationError = BannerUpdate400 | BannerUpdate403

    /**
 * @summary Update the sidebar banner
 */
export const useBannerUpdate = <TError = BannerUpdate400 | BannerUpdate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bannerUpdate>>, TError,{data: BannerUpdateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof bannerUpdate>>,
        TError,
        {data: BannerUpdateBody},
        TContext
      > => {

      const mutationOptions = getBannerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Paginated list of active plugin categories (emergent taxonomy; the sync-repo worker find-or-creates rows on first use). Read-only; no audit row.
 * @summary List plugin categories
 */
export const categoriesList = (
    params?: CategoriesListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<CategoriesList200>(
      {url: `/api/categories`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getCategoriesListQueryKey = (params?: CategoriesListParams,) => {
    return [
    `/api/categories`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCategoriesListQueryOptions = <TData = Awaited<ReturnType<typeof categoriesList>>, TError = CategoriesList400 | CategoriesList403>(params?: CategoriesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof categoriesList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCategoriesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof categoriesList>>> = ({ signal }) => categoriesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof categoriesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CategoriesListQueryResult = NonNullable<Awaited<ReturnType<typeof categoriesList>>>
export type CategoriesListQueryError = CategoriesList400 | CategoriesList403


/**
 * @summary List plugin categories
 */

export function useCategoriesList<TData = Awaited<ReturnType<typeof categoriesList>>, TError = CategoriesList400 | CategoriesList403>(
 params?: CategoriesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof categoriesList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCategoriesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List feature flags
 */
export const flagsList = (
    params?: FlagsListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<FlagsList200>(
      {url: `/api/flags`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getFlagsListQueryKey = (params?: FlagsListParams,) => {
    return [
    `/api/flags`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getFlagsListQueryOptions = <TData = Awaited<ReturnType<typeof flagsList>>, TError = FlagsList400 | FlagsList403>(params?: FlagsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof flagsList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFlagsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof flagsList>>> = ({ signal }) => flagsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof flagsList>>, TError, TData> & { queryKey: QueryKey }
}

export type FlagsListQueryResult = NonNullable<Awaited<ReturnType<typeof flagsList>>>
export type FlagsListQueryError = FlagsList400 | FlagsList403


/**
 * @summary List feature flags
 */

export function useFlagsList<TData = Awaited<ReturnType<typeof flagsList>>, TError = FlagsList400 | FlagsList403>(
 params?: FlagsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof flagsList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFlagsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all matching feature flags as a `text/csv` attachment. Same filter surface as `flags_list` (search, sort, enabled) but without pagination. Capped at 50 000 rows server-side. The `e2e-` prefix filter is preserved — test-only flags are excluded from the export.
 * @summary Export feature flags as CSV
 */
export const flagsExport = (
    params?: FlagsExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/flags/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getFlagsExportQueryKey = (params?: FlagsExportParams,) => {
    return [
    `/api/flags/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getFlagsExportQueryOptions = <TData = Awaited<ReturnType<typeof flagsExport>>, TError = FlagsExport400 | FlagsExport403>(params?: FlagsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof flagsExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFlagsExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof flagsExport>>> = ({ signal }) => flagsExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof flagsExport>>, TError, TData> & { queryKey: QueryKey }
}

export type FlagsExportQueryResult = NonNullable<Awaited<ReturnType<typeof flagsExport>>>
export type FlagsExportQueryError = FlagsExport400 | FlagsExport403


/**
 * @summary Export feature flags as CSV
 */

export function useFlagsExport<TData = Awaited<ReturnType<typeof flagsExport>>, TError = FlagsExport400 | FlagsExport403>(
 params?: FlagsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof flagsExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getFlagsExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Delete a feature flag
 */
export const flagsDelete = (
    key: string,
 ) => {
      
      
      return mutator<void>(
      {url: `/api/flags/${key}`, method: 'DELETE'
    },
      );
    }
  


export const getFlagsDeleteMutationOptions = <TError = FlagsDelete403 | FlagsDelete404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagsDelete>>, TError,{key: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof flagsDelete>>, TError,{key: string}, TContext> => {

const mutationKey = ['flagsDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof flagsDelete>>, {key: string}> = (props) => {
          const {key} = props ?? {};

          return  flagsDelete(key,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FlagsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof flagsDelete>>>
    
    export type FlagsDeleteMutationError = FlagsDelete403 | FlagsDelete404

    /**
 * @summary Delete a feature flag
 */
export const useFlagsDelete = <TError = FlagsDelete403 | FlagsDelete404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagsDelete>>, TError,{key: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof flagsDelete>>,
        TError,
        {key: string},
        TContext
      > => {

      const mutationOptions = getFlagsDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Full replacement. Flags are seeded — keys cannot be created at runtime.
 * @summary Update a feature flag
 */
export const flagsUpdate = (
    key: string,
    flagsUpdateBody: FlagsUpdateBody,
 ) => {
      
      
      return mutator<FlagsUpdate200>(
      {url: `/api/flags/${key}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: flagsUpdateBody
    },
      );
    }
  


export const getFlagsUpdateMutationOptions = <TError = FlagsUpdate400 | FlagsUpdate403 | FlagsUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagsUpdate>>, TError,{key: string;data: FlagsUpdateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof flagsUpdate>>, TError,{key: string;data: FlagsUpdateBody}, TContext> => {

const mutationKey = ['flagsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof flagsUpdate>>, {key: string;data: FlagsUpdateBody}> = (props) => {
          const {key,data} = props ?? {};

          return  flagsUpdate(key,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FlagsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof flagsUpdate>>>
    export type FlagsUpdateMutationBody = FlagsUpdateBody
    export type FlagsUpdateMutationError = FlagsUpdate400 | FlagsUpdate403 | FlagsUpdate404

    /**
 * @summary Update a feature flag
 */
export const useFlagsUpdate = <TError = FlagsUpdate400 | FlagsUpdate403 | FlagsUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof flagsUpdate>>, TError,{key: string;data: FlagsUpdateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof flagsUpdate>>,
        TError,
        {key: string;data: FlagsUpdateBody},
        TContext
      > => {

      const mutationOptions = getFlagsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Per-team commits, merged PRs, contributors, plugin count and last commit for the window, each with a commits-only sparkline on the same buckets as `metrics_contributions_timeseries`. Sorted by commits descending.
 * @summary Per-team contribution totals for the window
 */
export const metricsContributionsByTeam = (
    params?: MetricsContributionsByTeamParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<MetricsContributionsByTeam200>(
      {url: `/api/metrics/contributions/by-team`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getMetricsContributionsByTeamQueryKey = (params?: MetricsContributionsByTeamParams,) => {
    return [
    `/api/metrics/contributions/by-team`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMetricsContributionsByTeamQueryOptions = <TData = Awaited<ReturnType<typeof metricsContributionsByTeam>>, TError = MetricsContributionsByTeam400 | MetricsContributionsByTeam403>(params?: MetricsContributionsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsContributionsByTeam>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsContributionsByTeamQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsContributionsByTeam>>> = ({ signal }) => metricsContributionsByTeam(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricsContributionsByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type MetricsContributionsByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof metricsContributionsByTeam>>>
export type MetricsContributionsByTeamQueryError = MetricsContributionsByTeam400 | MetricsContributionsByTeam403


/**
 * @summary Per-team contribution totals for the window
 */

export function useMetricsContributionsByTeam<TData = Awaited<ReturnType<typeof metricsContributionsByTeam>>, TError = MetricsContributionsByTeam400 | MetricsContributionsByTeam403>(
 params?: MetricsContributionsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsContributionsByTeam>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMetricsContributionsByTeamQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Week- or month-grained buckets over `analytics_daily_contributions`, written nightly from ADO git history by the `collect-contributions` worker. Platform-UAI rows (`is_system = true`) are excluded. `contributors` is a ceiling — see the `contributors-ceiling` note.
 * @summary Commits / merged PRs / contributors over time
 */
export const metricsContributionsTimeseries = (
    params?: MetricsContributionsTimeseriesParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<MetricsContributionsTimeseries200>(
      {url: `/api/metrics/contributions/timeseries`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getMetricsContributionsTimeseriesQueryKey = (params?: MetricsContributionsTimeseriesParams,) => {
    return [
    `/api/metrics/contributions/timeseries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMetricsContributionsTimeseriesQueryOptions = <TData = Awaited<ReturnType<typeof metricsContributionsTimeseries>>, TError = MetricsContributionsTimeseries400 | MetricsContributionsTimeseries403>(params?: MetricsContributionsTimeseriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsContributionsTimeseries>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsContributionsTimeseriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsContributionsTimeseries>>> = ({ signal }) => metricsContributionsTimeseries(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricsContributionsTimeseries>>, TError, TData> & { queryKey: QueryKey }
}

export type MetricsContributionsTimeseriesQueryResult = NonNullable<Awaited<ReturnType<typeof metricsContributionsTimeseries>>>
export type MetricsContributionsTimeseriesQueryError = MetricsContributionsTimeseries400 | MetricsContributionsTimeseries403


/**
 * @summary Commits / merged PRs / contributors over time
 */

export function useMetricsContributionsTimeseries<TData = Awaited<ReturnType<typeof metricsContributionsTimeseries>>, TError = MetricsContributionsTimeseries400 | MetricsContributionsTimeseries403>(
 params?: MetricsContributionsTimeseriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsContributionsTimeseries>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMetricsContributionsTimeseriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Flat `text/csv` attachment carrying every series for the window (users, contributions, by-team, plugins) on one sheet, keyed by series + period. Same window/grain surface as the series routes, no pagination.
 * @summary Export the metrics series as CSV
 */
export const metricsExport = (
    params?: MetricsExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/metrics/export.csv`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getMetricsExportQueryKey = (params?: MetricsExportParams,) => {
    return [
    `/api/metrics/export.csv`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMetricsExportQueryOptions = <TData = Awaited<ReturnType<typeof metricsExport>>, TError = MetricsExport400 | MetricsExport403>(params?: MetricsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsExport>>> = ({ signal }) => metricsExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricsExport>>, TError, TData> & { queryKey: QueryKey }
}

export type MetricsExportQueryResult = NonNullable<Awaited<ReturnType<typeof metricsExport>>>
export type MetricsExportQueryError = MetricsExport400 | MetricsExport403


/**
 * @summary Export the metrics series as CSV
 */

export function useMetricsExport<TData = Awaited<ReturnType<typeof metricsExport>>, TError = MetricsExport400 | MetricsExport403>(
 params?: MetricsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMetricsExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * **Deprecated.** Unchanged behaviour, retained for contract stability. The signal behind it is dead: Claude Code installs a plugin by `git clone` of the team repo and never fetches the manifest, so `plugin.manifest_fetched` counts near-zero real installs. Nothing renders from it. A real install signal is tracked as a follow-up (metrics dashboard design §8.1). Trailing window — defaults to 30 days; max 90 days (matches the analytics purge horizon).
 * @summary Top plugins by install count (deprecated)
 */
export const metricsInstalls = (
    params?: MetricsInstallsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<MetricsInstalls200>(
      {url: `/api/metrics/installs`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getMetricsInstallsQueryKey = (params?: MetricsInstallsParams,) => {
    return [
    `/api/metrics/installs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMetricsInstallsQueryOptions = <TData = Awaited<ReturnType<typeof metricsInstalls>>, TError = MetricsInstalls400 | MetricsInstalls403>(params?: MetricsInstallsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsInstalls>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsInstallsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsInstalls>>> = ({ signal }) => metricsInstalls(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricsInstalls>>, TError, TData> & { queryKey: QueryKey }
}

export type MetricsInstallsQueryResult = NonNullable<Awaited<ReturnType<typeof metricsInstalls>>>
export type MetricsInstallsQueryError = MetricsInstalls400 | MetricsInstalls403


/**
 * @summary Top plugins by install count (deprecated)
 */

export function useMetricsInstalls<TData = Awaited<ReturnType<typeof metricsInstalls>>, TError = MetricsInstalls400 | MetricsInstalls403>(
 params?: MetricsInstallsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsInstalls>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMetricsInstallsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Week- or month-grained buckets over `plugins.created_at`. `plugins.hub_listed_at` is deliberately not used for history — `hub-mirror.ts` nulls and resets it, so it is a current-state marker only.
 * @summary Plugins created / cumulative over time
 */
export const metricsPluginsTimeseries = (
    params?: MetricsPluginsTimeseriesParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<MetricsPluginsTimeseries200>(
      {url: `/api/metrics/plugins/timeseries`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getMetricsPluginsTimeseriesQueryKey = (params?: MetricsPluginsTimeseriesParams,) => {
    return [
    `/api/metrics/plugins/timeseries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMetricsPluginsTimeseriesQueryOptions = <TData = Awaited<ReturnType<typeof metricsPluginsTimeseries>>, TError = MetricsPluginsTimeseries400 | MetricsPluginsTimeseries403>(params?: MetricsPluginsTimeseriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsPluginsTimeseries>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsPluginsTimeseriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsPluginsTimeseries>>> = ({ signal }) => metricsPluginsTimeseries(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricsPluginsTimeseries>>, TError, TData> & { queryKey: QueryKey }
}

export type MetricsPluginsTimeseriesQueryResult = NonNullable<Awaited<ReturnType<typeof metricsPluginsTimeseries>>>
export type MetricsPluginsTimeseriesQueryError = MetricsPluginsTimeseries400 | MetricsPluginsTimeseries403


/**
 * @summary Plugins created / cumulative over time
 */

export function useMetricsPluginsTimeseries<TData = Awaited<ReturnType<typeof metricsPluginsTimeseries>>, TError = MetricsPluginsTimeseries400 | MetricsPluginsTimeseries403>(
 params?: MetricsPluginsTimeseriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsPluginsTimeseries>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMetricsPluginsTimeseriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Every headline number on the `/metrics` page, plus `notes` — the per-number caveats, served from the API so the page, a CSV reader and any future consumer state the same thing. `contributionsCollectedThrough`, `sourcesEligible`, `sourcesNeverCollected` and `contributionsStaleAfterHours` report the contributions collector's freshness, so a consumer can tell four states apart that would otherwise all read as a measured zero: collected and current, collected but STALE (the collector has stopped — `contributions-stale`), eligible sources that have never been collected (a structural zero — `contributions-never-collected`), and NO eligible sources at all (nothing to collect, so no nightly run will change the numbers — `contributions-no-eligible-sources`). Freshness is computed over the collector's eligibility set; the contribution aggregates are not, so the two cover different rows.
 * @summary Marketplace headline metrics
 */
export const metricsSummary = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<MetricsSummary200>(
      {url: `/api/metrics/summary`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getMetricsSummaryQueryKey = () => {
    return [
    `/api/metrics/summary`
    ] as const;
    }

    
export const getMetricsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof metricsSummary>>, TError = MetricsSummary403>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsSummary>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsSummary>>> = ({ signal }) => metricsSummary(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricsSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type MetricsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof metricsSummary>>>
export type MetricsSummaryQueryError = MetricsSummary403


/**
 * @summary Marketplace headline metrics
 */

export function useMetricsSummary<TData = Awaited<ReturnType<typeof metricsSummary>>, TError = MetricsSummary403>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsSummary>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMetricsSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * **Deprecated.** Unchanged behaviour, retained for contract stability. Rolls up from `submissions`, which is empty in prod because ADO service hooks were never registered, so every counter reads zero. Use `metrics_contributions_by_team` instead — it reads git history. Tracked as a follow-up (metrics dashboard design §8.3).
 * @summary Per-team activity counters (deprecated)
 */
export const metricsTeamActivity = (
    params?: MetricsTeamActivityParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<MetricsTeamActivity200>(
      {url: `/api/metrics/team-activity`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getMetricsTeamActivityQueryKey = (params?: MetricsTeamActivityParams,) => {
    return [
    `/api/metrics/team-activity`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMetricsTeamActivityQueryOptions = <TData = Awaited<ReturnType<typeof metricsTeamActivity>>, TError = MetricsTeamActivity400 | MetricsTeamActivity403>(params?: MetricsTeamActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsTeamActivity>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsTeamActivityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsTeamActivity>>> = ({ signal }) => metricsTeamActivity(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricsTeamActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type MetricsTeamActivityQueryResult = NonNullable<Awaited<ReturnType<typeof metricsTeamActivity>>>
export type MetricsTeamActivityQueryError = MetricsTeamActivity400 | MetricsTeamActivity403


/**
 * @summary Per-team activity counters (deprecated)
 */

export function useMetricsTeamActivity<TData = Awaited<ReturnType<typeof metricsTeamActivity>>, TError = MetricsTeamActivity400 | MetricsTeamActivity403>(
 params?: MetricsTeamActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsTeamActivity>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMetricsTeamActivityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Week- or month-grained buckets over `users`. Excludes the seeded system actor and soft-deleted rows. `activeUsers` reads `last_login_at`, falling back to `updated_at` for buckets predating that column (flagged by the `active-users-fallback` note on `metrics_summary`).
 * @summary New / cumulative / active users over time
 */
export const metricsUsersTimeseries = (
    params?: MetricsUsersTimeseriesParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<MetricsUsersTimeseries200>(
      {url: `/api/metrics/users/timeseries`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getMetricsUsersTimeseriesQueryKey = (params?: MetricsUsersTimeseriesParams,) => {
    return [
    `/api/metrics/users/timeseries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMetricsUsersTimeseriesQueryOptions = <TData = Awaited<ReturnType<typeof metricsUsersTimeseries>>, TError = MetricsUsersTimeseries400 | MetricsUsersTimeseries403>(params?: MetricsUsersTimeseriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsUsersTimeseries>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsUsersTimeseriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsUsersTimeseries>>> = ({ signal }) => metricsUsersTimeseries(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricsUsersTimeseries>>, TError, TData> & { queryKey: QueryKey }
}

export type MetricsUsersTimeseriesQueryResult = NonNullable<Awaited<ReturnType<typeof metricsUsersTimeseries>>>
export type MetricsUsersTimeseriesQueryError = MetricsUsersTimeseries400 | MetricsUsersTimeseries403


/**
 * @summary New / cumulative / active users over time
 */

export function useMetricsUsersTimeseries<TData = Awaited<ReturnType<typeof metricsUsersTimeseries>>, TError = MetricsUsersTimeseries400 | MetricsUsersTimeseries403>(
 params?: MetricsUsersTimeseriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof metricsUsersTimeseries>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getMetricsUsersTimeseriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary List plugins (admin)
 */
export const pluginsList = (
    params?: PluginsListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<PluginsList200>(
      {url: `/api/plugins`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getPluginsListQueryKey = (params?: PluginsListParams,) => {
    return [
    `/api/plugins`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPluginsListQueryOptions = <TData = Awaited<ReturnType<typeof pluginsList>>, TError = PluginsList400 | PluginsList403>(params?: PluginsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pluginsList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPluginsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pluginsList>>> = ({ signal }) => pluginsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pluginsList>>, TError, TData> & { queryKey: QueryKey }
}

export type PluginsListQueryResult = NonNullable<Awaited<ReturnType<typeof pluginsList>>>
export type PluginsListQueryError = PluginsList400 | PluginsList403


/**
 * @summary List plugins (admin)
 */

export function usePluginsList<TData = Awaited<ReturnType<typeof pluginsList>>, TError = PluginsList400 | PluginsList403>(
 params?: PluginsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pluginsList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPluginsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Slug-addressed sibling of `plugins_get`, returning the identical detail payload. Exists because `/catalog/:slug` addresses a plugin by name; without it the UI resolved the slug by scanning a paginated list page and 404'd every plugin outside the first page. Unfiltered by hub-listing status, so pending deep-links still resolve. See ADR 0009.
 * @summary Get a single plugin by name with detail payload
 */
export const pluginsGetByName = (
    name: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<PluginsGetByName200>(
      {url: `/api/plugins/by-name/${name}`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getPluginsGetByNameQueryKey = (name?: string,) => {
    return [
    `/api/plugins/by-name/${name}`
    ] as const;
    }

    
export const getPluginsGetByNameQueryOptions = <TData = Awaited<ReturnType<typeof pluginsGetByName>>, TError = PluginsGetByName400 | PluginsGetByName403 | PluginsGetByName404>(name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pluginsGetByName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPluginsGetByNameQueryKey(name);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pluginsGetByName>>> = ({ signal }) => pluginsGetByName(name, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(name), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pluginsGetByName>>, TError, TData> & { queryKey: QueryKey }
}

export type PluginsGetByNameQueryResult = NonNullable<Awaited<ReturnType<typeof pluginsGetByName>>>
export type PluginsGetByNameQueryError = PluginsGetByName400 | PluginsGetByName403 | PluginsGetByName404


/**
 * @summary Get a single plugin by name with detail payload
 */

export function usePluginsGetByName<TData = Awaited<ReturnType<typeof pluginsGetByName>>, TError = PluginsGetByName400 | PluginsGetByName403 | PluginsGetByName404>(
 name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pluginsGetByName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPluginsGetByNameQueryOptions(name,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all plugins matching the filter + sort params as a `text/csv` attachment. Same filter surface as `plugins_list` (search, status, teamId, categoryId, authorId, sort) but without pagination. Capped at 50 000 rows server-side.
 * @summary Export plugins as CSV
 */
export const pluginsExport = (
    params?: PluginsExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/plugins/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getPluginsExportQueryKey = (params?: PluginsExportParams,) => {
    return [
    `/api/plugins/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPluginsExportQueryOptions = <TData = Awaited<ReturnType<typeof pluginsExport>>, TError = PluginsExport400 | PluginsExport403>(params?: PluginsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pluginsExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPluginsExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pluginsExport>>> = ({ signal }) => pluginsExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pluginsExport>>, TError, TData> & { queryKey: QueryKey }
}

export type PluginsExportQueryResult = NonNullable<Awaited<ReturnType<typeof pluginsExport>>>
export type PluginsExportQueryError = PluginsExport400 | PluginsExport403


/**
 * @summary Export plugins as CSV
 */

export function usePluginsExport<TData = Awaited<ReturnType<typeof pluginsExport>>, TError = PluginsExport400 | PluginsExport403>(
 params?: PluginsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pluginsExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPluginsExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Single-resource fetch returning the detail payload — the list row plus `readmeContent`, `skills`, and `sourceUrl` — so the plugin detail page renders without a second fetch.
 * @summary Get a single plugin with detail payload
 */
export const pluginsGet = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<PluginsGet200>(
      {url: `/api/plugins/${id}`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getPluginsGetQueryKey = (id?: string,) => {
    return [
    `/api/plugins/${id}`
    ] as const;
    }

    
export const getPluginsGetQueryOptions = <TData = Awaited<ReturnType<typeof pluginsGet>>, TError = PluginsGet400 | PluginsGet403 | PluginsGet404>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pluginsGet>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPluginsGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof pluginsGet>>> = ({ signal }) => pluginsGet(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pluginsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type PluginsGetQueryResult = NonNullable<Awaited<ReturnType<typeof pluginsGet>>>
export type PluginsGetQueryError = PluginsGet400 | PluginsGet403 | PluginsGet404


/**
 * @summary Get a single plugin with detail payload
 */

export function usePluginsGet<TData = Awaited<ReturnType<typeof pluginsGet>>, TError = PluginsGet400 | PluginsGet403 | PluginsGet404>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof pluginsGet>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPluginsGetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Edit a plugin (description)
 */
export const pluginsUpdate = (
    id: string,
    pluginsUpdateBody: PluginsUpdateBody,
 ) => {
      
      
      return mutator<PluginsUpdate200>(
      {url: `/api/plugins/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pluginsUpdateBody
    },
      );
    }
  


export const getPluginsUpdateMutationOptions = <TError = PluginsUpdate400 | PluginsUpdate403 | PluginsUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsUpdate>>, TError,{id: string;data: PluginsUpdateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pluginsUpdate>>, TError,{id: string;data: PluginsUpdateBody}, TContext> => {

const mutationKey = ['pluginsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pluginsUpdate>>, {id: string;data: PluginsUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  pluginsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PluginsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof pluginsUpdate>>>
    export type PluginsUpdateMutationBody = PluginsUpdateBody
    export type PluginsUpdateMutationError = PluginsUpdate400 | PluginsUpdate403 | PluginsUpdate404

    /**
 * @summary Edit a plugin (description)
 */
export const usePluginsUpdate = <TError = PluginsUpdate400 | PluginsUpdate403 | PluginsUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsUpdate>>, TError,{id: string;data: PluginsUpdateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof pluginsUpdate>>,
        TError,
        {id: string;data: PluginsUpdateBody},
        TContext
      > => {

      const mutationOptions = getPluginsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Mark a plugin deprecated
 */
export const pluginsDeprecate = (
    id: string,
    pluginsDeprecateBody: PluginsDeprecateBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<PluginsDeprecate200>(
      {url: `/api/plugins/${id}/deprecate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pluginsDeprecateBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getPluginsDeprecateMutationOptions = <TError = PluginsDeprecate403 | PluginsDeprecate404 | PluginsDeprecate409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsDeprecate>>, TError,{id: string;data: PluginsDeprecateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pluginsDeprecate>>, TError,{id: string;data: PluginsDeprecateBody}, TContext> => {

const mutationKey = ['pluginsDeprecate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pluginsDeprecate>>, {id: string;data: PluginsDeprecateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  pluginsDeprecate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PluginsDeprecateMutationResult = NonNullable<Awaited<ReturnType<typeof pluginsDeprecate>>>
    export type PluginsDeprecateMutationBody = PluginsDeprecateBody
    export type PluginsDeprecateMutationError = PluginsDeprecate403 | PluginsDeprecate404 | PluginsDeprecate409

    /**
 * @summary Mark a plugin deprecated
 */
export const usePluginsDeprecate = <TError = PluginsDeprecate403 | PluginsDeprecate404 | PluginsDeprecate409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsDeprecate>>, TError,{id: string;data: PluginsDeprecateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof pluginsDeprecate>>,
        TError,
        {id: string;data: PluginsDeprecateBody},
        TContext
      > => {

      const mutationOptions = getPluginsDeprecateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Clear `deprecated_at`
 */
export const pluginsUnmarkDeprecated = (
    id: string,
    pluginsUnmarkDeprecatedBody: PluginsUnmarkDeprecatedBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<PluginsUnmarkDeprecated200>(
      {url: `/api/plugins/${id}/unmark-deprecated`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pluginsUnmarkDeprecatedBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getPluginsUnmarkDeprecatedMutationOptions = <TError = PluginsUnmarkDeprecated403 | PluginsUnmarkDeprecated404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsUnmarkDeprecated>>, TError,{id: string;data: PluginsUnmarkDeprecatedBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pluginsUnmarkDeprecated>>, TError,{id: string;data: PluginsUnmarkDeprecatedBody}, TContext> => {

const mutationKey = ['pluginsUnmarkDeprecated'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pluginsUnmarkDeprecated>>, {id: string;data: PluginsUnmarkDeprecatedBody}> = (props) => {
          const {id,data} = props ?? {};

          return  pluginsUnmarkDeprecated(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PluginsUnmarkDeprecatedMutationResult = NonNullable<Awaited<ReturnType<typeof pluginsUnmarkDeprecated>>>
    export type PluginsUnmarkDeprecatedMutationBody = PluginsUnmarkDeprecatedBody
    export type PluginsUnmarkDeprecatedMutationError = PluginsUnmarkDeprecated403 | PluginsUnmarkDeprecated404

    /**
 * @summary Clear `deprecated_at`
 */
export const usePluginsUnmarkDeprecated = <TError = PluginsUnmarkDeprecated403 | PluginsUnmarkDeprecated404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsUnmarkDeprecated>>, TError,{id: string;data: PluginsUnmarkDeprecatedBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof pluginsUnmarkDeprecated>>,
        TError,
        {id: string;data: PluginsUnmarkDeprecatedBody},
        TContext
      > => {

      const mutationOptions = getPluginsUnmarkDeprecatedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Restore a yanked plugin
 */
export const pluginsUnyank = (
    id: string,
    pluginsUnyankBody: PluginsUnyankBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<PluginsUnyank200>(
      {url: `/api/plugins/${id}/unyank`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pluginsUnyankBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getPluginsUnyankMutationOptions = <TError = PluginsUnyank403 | PluginsUnyank404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsUnyank>>, TError,{id: string;data: PluginsUnyankBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pluginsUnyank>>, TError,{id: string;data: PluginsUnyankBody}, TContext> => {

const mutationKey = ['pluginsUnyank'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pluginsUnyank>>, {id: string;data: PluginsUnyankBody}> = (props) => {
          const {id,data} = props ?? {};

          return  pluginsUnyank(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PluginsUnyankMutationResult = NonNullable<Awaited<ReturnType<typeof pluginsUnyank>>>
    export type PluginsUnyankMutationBody = PluginsUnyankBody
    export type PluginsUnyankMutationError = PluginsUnyank403 | PluginsUnyank404

    /**
 * @summary Restore a yanked plugin
 */
export const usePluginsUnyank = <TError = PluginsUnyank403 | PluginsUnyank404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsUnyank>>, TError,{id: string;data: PluginsUnyankBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof pluginsUnyank>>,
        TError,
        {id: string;data: PluginsUnyankBody},
        TContext
      > => {

      const mutationOptions = getPluginsUnyankMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Removes a plugin from the marketplace manifest. `reason` must be ≥ 10 characters.
 * @summary Yank a plugin (with mandatory reason)
 */
export const pluginsYank = (
    id: string,
    pluginsYankBody: PluginsYankBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<PluginsYank200>(
      {url: `/api/plugins/${id}/yank`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pluginsYankBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getPluginsYankMutationOptions = <TError = PluginsYank400 | PluginsYank403 | PluginsYank404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsYank>>, TError,{id: string;data: PluginsYankBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pluginsYank>>, TError,{id: string;data: PluginsYankBody}, TContext> => {

const mutationKey = ['pluginsYank'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pluginsYank>>, {id: string;data: PluginsYankBody}> = (props) => {
          const {id,data} = props ?? {};

          return  pluginsYank(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PluginsYankMutationResult = NonNullable<Awaited<ReturnType<typeof pluginsYank>>>
    export type PluginsYankMutationBody = PluginsYankBody
    export type PluginsYankMutationError = PluginsYank400 | PluginsYank403 | PluginsYank404

    /**
 * @summary Yank a plugin (with mandatory reason)
 */
export const usePluginsYank = <TError = PluginsYank400 | PluginsYank403 | PluginsYank404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pluginsYank>>, TError,{id: string;data: PluginsYankBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof pluginsYank>>,
        TError,
        {id: string;data: PluginsYankBody},
        TContext
      > => {

      const mutationOptions = getPluginsYankMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List roles
 */
export const rolesList = (
    params?: RolesListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<RolesList200>(
      {url: `/api/roles`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getRolesListQueryKey = (params?: RolesListParams,) => {
    return [
    `/api/roles`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getRolesListQueryOptions = <TData = Awaited<ReturnType<typeof rolesList>>, TError = RolesList400 | RolesList403>(params?: RolesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesList>>> = ({ signal }) => rolesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData> & { queryKey: QueryKey }
}

export type RolesListQueryResult = NonNullable<Awaited<ReturnType<typeof rolesList>>>
export type RolesListQueryError = RolesList400 | RolesList403


/**
 * @summary List roles
 */

export function useRolesList<TData = Awaited<ReturnType<typeof rolesList>>, TError = RolesList400 | RolesList403>(
 params?: RolesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof rolesList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRolesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all matching roles as a `text/csv` attachment. Same filter surface as `roles_list` (search, sort) but without pagination. Capped at 50 000 rows server-side. Columns: Name, Description, Permissions.
 * @summary Export roles as CSV
 */
export const rolesExport = (
    params?: RolesExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/roles/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getRolesExportQueryKey = (params?: RolesExportParams,) => {
    return [
    `/api/roles/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getRolesExportQueryOptions = <TData = Awaited<ReturnType<typeof rolesExport>>, TError = RolesExport400 | RolesExport403>(params?: RolesExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof rolesExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesExport>>> = ({ signal }) => rolesExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesExport>>, TError, TData> & { queryKey: QueryKey }
}

export type RolesExportQueryResult = NonNullable<Awaited<ReturnType<typeof rolesExport>>>
export type RolesExportQueryError = RolesExport400 | RolesExport403


/**
 * @summary Export roles as CSV
 */

export function useRolesExport<TData = Awaited<ReturnType<typeof rolesExport>>, TError = RolesExport400 | RolesExport403>(
 params?: RolesExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof rolesExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRolesExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Full permission catalog
 */
export const rolesPermissions = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<RolesPermissions200>(
      {url: `/api/roles/permissions`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getRolesPermissionsQueryKey = () => {
    return [
    `/api/roles/permissions`
    ] as const;
    }

    
export const getRolesPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof rolesPermissions>>, TError = RolesPermissions403>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof rolesPermissions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRolesPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof rolesPermissions>>> = ({ signal }) => rolesPermissions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rolesPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type RolesPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof rolesPermissions>>>
export type RolesPermissionsQueryError = RolesPermissions403


/**
 * @summary Full permission catalog
 */

export function useRolesPermissions<TData = Awaited<ReturnType<typeof rolesPermissions>>, TError = RolesPermissions403>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof rolesPermissions>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRolesPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Permissions must be present in the seeded catalog (the DB FK on `role_permissions.permission_name` enforces the same rule at write time). Cache fan-out invalidates every user holding the role across replicas.
 * @summary Update a role (description + permission set)
 */
export const rolesUpdate = (
    name: string,
    rolesUpdateBody: RolesUpdateBody,
 ) => {
      
      
      return mutator<RolesUpdate200>(
      {url: `/api/roles/${name}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: rolesUpdateBody
    },
      );
    }
  


export const getRolesUpdateMutationOptions = <TError = RolesUpdate400 | RolesUpdate403 | RolesUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError,{name: string;data: RolesUpdateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError,{name: string;data: RolesUpdateBody}, TContext> => {

const mutationKey = ['rolesUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rolesUpdate>>, {name: string;data: RolesUpdateBody}> = (props) => {
          const {name,data} = props ?? {};

          return  rolesUpdate(name,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RolesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof rolesUpdate>>>
    export type RolesUpdateMutationBody = RolesUpdateBody
    export type RolesUpdateMutationError = RolesUpdate400 | RolesUpdate403 | RolesUpdate404

    /**
 * @summary Update a role (description + permission set)
 */
export const useRolesUpdate = <TError = RolesUpdate400 | RolesUpdate403 | RolesUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rolesUpdate>>, TError,{name: string;data: RolesUpdateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof rolesUpdate>>,
        TError,
        {name: string;data: RolesUpdateBody},
        TContext
      > => {

      const mutationOptions = getRolesUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Paginated admin list of provisioned sources. Supports `sort` (signed comma-joined field: name, status, lastSync, updatedAt) and `status` (comma-joined filter: provisioning, active, failed). Optional `orphaned=true` filters to rows with status=failed AND team_id IS NULL.
 * @summary List plugin sources (admin)
 */
export const sourcesList = (
    params?: SourcesListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<SourcesList200>(
      {url: `/api/sources`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getSourcesListQueryKey = (params?: SourcesListParams,) => {
    return [
    `/api/sources`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSourcesListQueryOptions = <TData = Awaited<ReturnType<typeof sourcesList>>, TError = SourcesList400 | SourcesList403>(params?: SourcesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSourcesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesList>>> = ({ signal }) => sourcesList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourcesList>>, TError, TData> & { queryKey: QueryKey }
}

export type SourcesListQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesList>>>
export type SourcesListQueryError = SourcesList400 | SourcesList403


/**
 * @summary List plugin sources (admin)
 */

export function useSourcesList<TData = Awaited<ReturnType<typeof sourcesList>>, TError = SourcesList400 | SourcesList403>(
 params?: SourcesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSourcesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all sources matching the filter + sort params as a text/csv attachment. Same filter surface as sources_list (sort, status, orphaned, search) but without pagination. Capped at 50 000 rows server-side.
 * @summary Export sources as CSV
 */
export const sourcesExport = (
    params?: SourcesExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/sources/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getSourcesExportQueryKey = (params?: SourcesExportParams,) => {
    return [
    `/api/sources/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSourcesExportQueryOptions = <TData = Awaited<ReturnType<typeof sourcesExport>>, TError = SourcesExport400 | SourcesExport403>(params?: SourcesExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSourcesExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesExport>>> = ({ signal }) => sourcesExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourcesExport>>, TError, TData> & { queryKey: QueryKey }
}

export type SourcesExportQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesExport>>>
export type SourcesExportQueryError = SourcesExport400 | SourcesExport403


/**
 * @summary Export sources as CSV
 */

export function useSourcesExport<TData = Awaited<ReturnType<typeof sourcesExport>>, TError = SourcesExport400 | SourcesExport403>(
 params?: SourcesExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSourcesExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Webhook secret values are never exposed; the row carries `hasPendingSecret` to drive the rotation widget.
 * @summary Source detail (admin)
 */
export const sourcesGet = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<SourcesGet200>(
      {url: `/api/sources/${id}`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getSourcesGetQueryKey = (id?: string,) => {
    return [
    `/api/sources/${id}`
    ] as const;
    }

    
export const getSourcesGetQueryOptions = <TData = Awaited<ReturnType<typeof sourcesGet>>, TError = SourcesGet403 | SourcesGet404>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGet>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSourcesGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesGet>>> = ({ signal }) => sourcesGet(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourcesGet>>, TError, TData> & { queryKey: QueryKey }
}

export type SourcesGetQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesGet>>>
export type SourcesGetQueryError = SourcesGet403 | SourcesGet404


/**
 * @summary Source detail (admin)
 */

export function useSourcesGet<TData = Awaited<ReturnType<typeof sourcesGet>>, TError = SourcesGet403 | SourcesGet404>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesGet>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSourcesGetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Admin inverse of the `reconcile-sync` auto-retirement (`source.archived_repo_gone`). Fail-closed: confirms the ADO repo exists again via `getRepo` before mutating — a still-missing repo returns 409 `REPO_STILL_GONE`. On success clears `deleted_at`, flips `status` to `active`, un-yanks the plugins the retirement flow yanked, and emits `source.reactivated`. Scoped to repo-gone retirements (matched on the `provision_error` marker), so a team-deleted source is never a candidate (→ 404).
 * @summary Reactivate a source whose deleted ADO repo has reappeared
 */
export const sourcesReactivate = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<SourcesReactivate200>(
      {url: `/api/sources/${id}/reactivate`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSourcesReactivateMutationOptions = <TError = SourcesReactivate403 | SourcesReactivate404 | SourcesReactivate409 | SourcesReactivate502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesReactivate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sourcesReactivate>>, TError,{id: string}, TContext> => {

const mutationKey = ['sourcesReactivate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesReactivate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sourcesReactivate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SourcesReactivateMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesReactivate>>>
    
    export type SourcesReactivateMutationError = SourcesReactivate403 | SourcesReactivate404 | SourcesReactivate409 | SourcesReactivate502

    /**
 * @summary Reactivate a source whose deleted ADO repo has reappeared
 */
export const useSourcesReactivate = <TError = SourcesReactivate403 | SourcesReactivate404 | SourcesReactivate409 | SourcesReactivate502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesReactivate>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sourcesReactivate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSourcesReactivateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Non-destructive: paths only in the team repo are left untouched (preserves team-authored work). When the template tree matches the team tree exactly the route short-circuits with `prUrl: null` and no PR is opened. The branch name is deterministic (`template/refresh-${shortSha}`) so repeated calls idempotently target the same branch and PR.
 * @summary PR template updates into an existing team repo
 */
export const sourcesRefreshTemplate = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<SourcesRefreshTemplate200>(
      {url: `/api/sources/${id}/refresh-template`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSourcesRefreshTemplateMutationOptions = <TError = SourcesRefreshTemplate403 | SourcesRefreshTemplate404 | SourcesRefreshTemplate409 | SourcesRefreshTemplate500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesRefreshTemplate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sourcesRefreshTemplate>>, TError,{id: string}, TContext> => {

const mutationKey = ['sourcesRefreshTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesRefreshTemplate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sourcesRefreshTemplate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SourcesRefreshTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesRefreshTemplate>>>
    
    export type SourcesRefreshTemplateMutationError = SourcesRefreshTemplate403 | SourcesRefreshTemplate404 | SourcesRefreshTemplate409 | SourcesRefreshTemplate500

    /**
 * @summary PR template updates into an existing team repo
 */
export const useSourcesRefreshTemplate = <TError = SourcesRefreshTemplate403 | SourcesRefreshTemplate404 | SourcesRefreshTemplate409 | SourcesRefreshTemplate500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesRefreshTemplate>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sourcesRefreshTemplate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSourcesRefreshTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Backfills the ADO service-hook registration deferred by `provision-team` step 6 when the per-team UAI lacked `ServiceHook:EditSubscriptions` at provision time. On success flips `plugin_sources.webhook_enabled = true` and emits `source.webhook_registered`. Returns the ADO subscription id. See ADR-0003.
 * @summary Re-register an ADO webhook for a source (admin backfill)
 */
export const sourcesRegisterHook = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<SourcesRegisterHook200>(
      {url: `/api/sources/${id}/register-hook`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSourcesRegisterHookMutationOptions = <TError = SourcesRegisterHook403 | SourcesRegisterHook404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesRegisterHook>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sourcesRegisterHook>>, TError,{id: string}, TContext> => {

const mutationKey = ['sourcesRegisterHook'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesRegisterHook>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sourcesRegisterHook(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SourcesRegisterHookMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesRegisterHook>>>
    
    export type SourcesRegisterHookMutationError = SourcesRegisterHook403 | SourcesRegisterHook404

    /**
 * @summary Re-register an ADO webhook for a source (admin backfill)
 */
export const useSourcesRegisterHook = <TError = SourcesRegisterHook403 | SourcesRegisterHook404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesRegisterHook>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sourcesRegisterHook>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSourcesRegisterHookMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * `phase=begin` writes a new secret to KV + ADO + `webhook_secret_pending` and returns 202; the operator observes deliveries during a 5-minute window; `phase=promote` swaps `webhook_secret_pending` → `webhook_secret`.
 * @summary Rotate webhook secret (two-phase)
 */
export const sourcesRotateSecret = (
    id: string,
    sourcesRotateSecretBody: SourcesRotateSecretBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<SourcesRotateSecret200 | SourcesRotateSecret202>(
      {url: `/api/sources/${id}/rotate-webhook-secret`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sourcesRotateSecretBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSourcesRotateSecretMutationOptions = <TError = SourcesRotateSecret400 | SourcesRotateSecret403 | SourcesRotateSecret404 | SourcesRotateSecret409 | SourcesRotateSecret502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesRotateSecret>>, TError,{id: string;data: SourcesRotateSecretBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sourcesRotateSecret>>, TError,{id: string;data: SourcesRotateSecretBody}, TContext> => {

const mutationKey = ['sourcesRotateSecret'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesRotateSecret>>, {id: string;data: SourcesRotateSecretBody}> = (props) => {
          const {id,data} = props ?? {};

          return  sourcesRotateSecret(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SourcesRotateSecretMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesRotateSecret>>>
    export type SourcesRotateSecretMutationBody = SourcesRotateSecretBody
    export type SourcesRotateSecretMutationError = SourcesRotateSecret400 | SourcesRotateSecret403 | SourcesRotateSecret404 | SourcesRotateSecret409 | SourcesRotateSecret502

    /**
 * @summary Rotate webhook secret (two-phase)
 */
export const useSourcesRotateSecret = <TError = SourcesRotateSecret400 | SourcesRotateSecret403 | SourcesRotateSecret404 | SourcesRotateSecret409 | SourcesRotateSecret502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesRotateSecret>>, TError,{id: string;data: SourcesRotateSecretBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sourcesRotateSecret>>,
        TError,
        {id: string;data: SourcesRotateSecretBody},
        TContext
      > => {

      const mutationOptions = getSourcesRotateSecretMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Resolves the source repo's current HEAD and enqueues a `sync-repo` job for it, exactly as a webhook push would. The jobId is uniquified per invocation so a manual trigger is never deduped against a still-pending webhook-enqueued job for the same SHA. Replaces the redis-cli manual-enqueue runbook procedure.
 * @summary Manually enqueue a repo sync for a source
 */
export const sourcesSync = (
    id: string,
    sourcesSyncBody: SourcesSyncBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<SourcesSync202>(
      {url: `/api/sources/${id}/sync`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sourcesSyncBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSourcesSyncMutationOptions = <TError = SourcesSync400 | SourcesSync403 | SourcesSync404 | SourcesSync409 | SourcesSync502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesSync>>, TError,{id: string;data: SourcesSyncBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sourcesSync>>, TError,{id: string;data: SourcesSyncBody}, TContext> => {

const mutationKey = ['sourcesSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sourcesSync>>, {id: string;data: SourcesSyncBody}> = (props) => {
          const {id,data} = props ?? {};

          return  sourcesSync(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SourcesSyncMutationResult = NonNullable<Awaited<ReturnType<typeof sourcesSync>>>
    export type SourcesSyncMutationBody = SourcesSyncBody
    export type SourcesSyncMutationError = SourcesSync400 | SourcesSync403 | SourcesSync404 | SourcesSync409 | SourcesSync502

    /**
 * @summary Manually enqueue a repo sync for a source
 */
export const useSourcesSync = <TError = SourcesSync400 | SourcesSync403 | SourcesSync404 | SourcesSync409 | SourcesSync502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sourcesSync>>, TError,{id: string;data: SourcesSyncBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof sourcesSync>>,
        TError,
        {id: string;data: SourcesSyncBody},
        TContext
      > => {

      const mutationOptions = getSourcesSyncMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Powers operator verification during the §7.5 secret-rotation observation window.
 * @summary Webhook sync history for a source
 */
export const sourcesSyncJobs = (
    id: string,
    params?: SourcesSyncJobsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<SourcesSyncJobs200>(
      {url: `/api/sources/${id}/sync-jobs`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getSourcesSyncJobsQueryKey = (id?: string,
    params?: SourcesSyncJobsParams,) => {
    return [
    `/api/sources/${id}/sync-jobs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSourcesSyncJobsQueryOptions = <TData = Awaited<ReturnType<typeof sourcesSyncJobs>>, TError = SourcesSyncJobs400 | SourcesSyncJobs403 | SourcesSyncJobs404>(id: string,
    params?: SourcesSyncJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesSyncJobs>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSourcesSyncJobsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sourcesSyncJobs>>> = ({ signal }) => sourcesSyncJobs(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sourcesSyncJobs>>, TError, TData> & { queryKey: QueryKey }
}

export type SourcesSyncJobsQueryResult = NonNullable<Awaited<ReturnType<typeof sourcesSyncJobs>>>
export type SourcesSyncJobsQueryError = SourcesSyncJobs400 | SourcesSyncJobs403 | SourcesSyncJobs404


/**
 * @summary Webhook sync history for a source
 */

export function useSourcesSyncJobs<TData = Awaited<ReturnType<typeof sourcesSyncJobs>>, TError = SourcesSyncJobs400 | SourcesSyncJobs403 | SourcesSyncJobs404>(
 id: string,
    params?: SourcesSyncJobsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sourcesSyncJobs>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSourcesSyncJobsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Anonymous status probe used by the SPA to decide whether to render the maintenance page. Reports the `maintenance-mode` feature-flag state to every caller (anon or authed). `/api/flags` requires `flags:view` so this endpoint is the smallest surface that lets every visitor learn the kill-switch state. Anonymous reachability is contract-derived: this route carries `anonymous: true`, which the API gate resolves via `isAnonymousOperation` (`marketplace-api/src/plugins/auth.ts`); the SWA route carveout (`marketplace-ui/public/staticwebapp.config.template.json`) exposes it at the edge.
 * @summary Public maintenance-mode probe
 */
export const statusGet = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<StatusGet200>(
      {url: `/api/status`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getStatusGetQueryKey = () => {
    return [
    `/api/status`
    ] as const;
    }

    
export const getStatusGetQueryOptions = <TData = Awaited<ReturnType<typeof statusGet>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof statusGet>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStatusGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof statusGet>>> = ({ signal }) => statusGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof statusGet>>, TError, TData> & { queryKey: QueryKey }
}

export type StatusGetQueryResult = NonNullable<Awaited<ReturnType<typeof statusGet>>>
export type StatusGetQueryError = unknown


/**
 * @summary Public maintenance-mode probe
 */

export function useStatusGet<TData = Awaited<ReturnType<typeof statusGet>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof statusGet>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getStatusGetQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Auth-only at the route layer, then row-level scoped in the service: callers WITH `submissions:view` see the full queue, everyone else is auto-scoped to their own `submitter_id`. A `submitterId` filter is honoured but ANDs with that scope, so a non-admin asking for another user's rows gets an empty page (never a 403). The `submissions:view` permission widens scope; it is not required to call the route.
 * @summary List submissions
 */
export const submissionsList = (
    params?: SubmissionsListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<SubmissionsList200>(
      {url: `/api/submissions`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getSubmissionsListQueryKey = (params?: SubmissionsListParams,) => {
    return [
    `/api/submissions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSubmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof submissionsList>>, TError = SubmissionsList400>(params?: SubmissionsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof submissionsList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubmissionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof submissionsList>>> = ({ signal }) => submissionsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof submissionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type SubmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof submissionsList>>>
export type SubmissionsListQueryError = SubmissionsList400


/**
 * @summary List submissions
 */

export function useSubmissionsList<TData = Awaited<ReturnType<typeof submissionsList>>, TError = SubmissionsList400>(
 params?: SubmissionsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof submissionsList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSubmissionsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Multipart upload (≤ submission cap). Returns 202 + `{submissionId, statusUrl}`. Failures collapse to canonical envelopes (MISSING_FILE / TOO_LARGE / NOT_ZIP / MULTIPLE_FILES / MISSING_MULTIPART / UPLOAD_FAILED).
 * @summary Upload a submission ZIP
 */
export const submissionsCreate = (
    submissionsCreateBody: SubmissionsCreateBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(submissionsCreateBody.teamId !== undefined) {
 formData.append(`teamId`, submissionsCreateBody.teamId)
 }
formData.append(`zip`, submissionsCreateBody.zip)

      return mutator<SubmissionsCreate202>(
      {url: `/api/submissions`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSubmissionsCreateMutationOptions = <TError = SubmissionsCreate400 | SubmissionsCreate403 | SubmissionsCreate413 | SubmissionsCreate415 | SubmissionsCreate429 | SubmissionsCreate502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submissionsCreate>>, TError,{data: SubmissionsCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submissionsCreate>>, TError,{data: SubmissionsCreateBody}, TContext> => {

const mutationKey = ['submissionsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submissionsCreate>>, {data: SubmissionsCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  submissionsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof submissionsCreate>>>
    export type SubmissionsCreateMutationBody = SubmissionsCreateBody
    export type SubmissionsCreateMutationError = SubmissionsCreate400 | SubmissionsCreate403 | SubmissionsCreate413 | SubmissionsCreate415 | SubmissionsCreate429 | SubmissionsCreate502

    /**
 * @summary Upload a submission ZIP
 */
export const useSubmissionsCreate = <TError = SubmissionsCreate400 | SubmissionsCreate403 | SubmissionsCreate413 | SubmissionsCreate415 | SubmissionsCreate429 | SubmissionsCreate502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submissionsCreate>>, TError,{data: SubmissionsCreateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submissionsCreate>>,
        TError,
        {data: SubmissionsCreateBody},
        TContext
      > => {

      const mutationOptions = getSubmissionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Exports all submissions matching the filter + sort params as a `text/csv` attachment. Same filter surface as `submissions_list` (status, type, submitterId, teamId, categoryId, sort) but without pagination. Capped at 50 000 rows server-side. Also serves MySubmissions export (Plan 3 Task 10) with `submitterId` pre-bound on the UI side.
 * @summary Export submissions as CSV
 */
export const submissionsExport = (
    params?: SubmissionsExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/submissions/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getSubmissionsExportQueryKey = (params?: SubmissionsExportParams,) => {
    return [
    `/api/submissions/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSubmissionsExportQueryOptions = <TData = Awaited<ReturnType<typeof submissionsExport>>, TError = SubmissionsExport400 | SubmissionsExport403>(params?: SubmissionsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof submissionsExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubmissionsExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof submissionsExport>>> = ({ signal }) => submissionsExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof submissionsExport>>, TError, TData> & { queryKey: QueryKey }
}

export type SubmissionsExportQueryResult = NonNullable<Awaited<ReturnType<typeof submissionsExport>>>
export type SubmissionsExportQueryError = SubmissionsExport400 | SubmissionsExport403


/**
 * @summary Export submissions as CSV
 */

export function useSubmissionsExport<TData = Awaited<ReturnType<typeof submissionsExport>>, TError = SubmissionsExport400 | SubmissionsExport403>(
 params?: SubmissionsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof submissionsExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSubmissionsExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Polled by `marketplace status` and the UI in-progress card. Auth-only at the route layer; the service returns the row to the submitter (self) or a caller holding `submissions:view`, and 403 FORBIDDEN to anyone else. Existence is confirmed before the 403, so the 404-vs-403 split is not information-leaking.
 * @summary Submission status
 */
export const submissionsGet = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<SubmissionsGet200>(
      {url: `/api/submissions/${id}`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getSubmissionsGetQueryKey = (id?: string,) => {
    return [
    `/api/submissions/${id}`
    ] as const;
    }

    
export const getSubmissionsGetQueryOptions = <TData = Awaited<ReturnType<typeof submissionsGet>>, TError = SubmissionsGet403 | SubmissionsGet404>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof submissionsGet>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubmissionsGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof submissionsGet>>> = ({ signal }) => submissionsGet(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof submissionsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type SubmissionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof submissionsGet>>>
export type SubmissionsGetQueryError = SubmissionsGet403 | SubmissionsGet404


/**
 * @summary Submission status
 */

export function useSubmissionsGet<TData = Awaited<ReturnType<typeof submissionsGet>>, TError = SubmissionsGet403 | SubmissionsGet404>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof submissionsGet>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSubmissionsGetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Two-admin guard: a submitter cannot approve their own submission (returns 403 SELF_APPROVAL_FORBIDDEN).
 * @summary Approve a submission
 */
export const submissionsApprove = (
    id: string,
    submissionsApproveBody: SubmissionsApproveBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<SubmissionsApprove200>(
      {url: `/api/submissions/${id}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submissionsApproveBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSubmissionsApproveMutationOptions = <TError = SubmissionsApprove403 | SubmissionsApprove404 | SubmissionsApprove409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submissionsApprove>>, TError,{id: string;data: SubmissionsApproveBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submissionsApprove>>, TError,{id: string;data: SubmissionsApproveBody}, TContext> => {

const mutationKey = ['submissionsApprove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submissionsApprove>>, {id: string;data: SubmissionsApproveBody}> = (props) => {
          const {id,data} = props ?? {};

          return  submissionsApprove(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmissionsApproveMutationResult = NonNullable<Awaited<ReturnType<typeof submissionsApprove>>>
    export type SubmissionsApproveMutationBody = SubmissionsApproveBody
    export type SubmissionsApproveMutationError = SubmissionsApprove403 | SubmissionsApprove404 | SubmissionsApprove409

    /**
 * @summary Approve a submission
 */
export const useSubmissionsApprove = <TError = SubmissionsApprove403 | SubmissionsApprove404 | SubmissionsApprove409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submissionsApprove>>, TError,{id: string;data: SubmissionsApproveBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submissionsApprove>>,
        TError,
        {id: string;data: SubmissionsApproveBody},
        TContext
      > => {

      const mutationOptions = getSubmissionsApproveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Mandatory `reason` (≥ 10 chars). Best-effort blob retag to `status=rejected` post-commit.
 * @summary Reject a submission
 */
export const submissionsReject = (
    id: string,
    submissionsRejectBody: SubmissionsRejectBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<SubmissionsReject200>(
      {url: `/api/submissions/${id}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submissionsRejectBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSubmissionsRejectMutationOptions = <TError = SubmissionsReject400 | SubmissionsReject403 | SubmissionsReject404 | SubmissionsReject409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submissionsReject>>, TError,{id: string;data: SubmissionsRejectBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submissionsReject>>, TError,{id: string;data: SubmissionsRejectBody}, TContext> => {

const mutationKey = ['submissionsReject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submissionsReject>>, {id: string;data: SubmissionsRejectBody}> = (props) => {
          const {id,data} = props ?? {};

          return  submissionsReject(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmissionsRejectMutationResult = NonNullable<Awaited<ReturnType<typeof submissionsReject>>>
    export type SubmissionsRejectMutationBody = SubmissionsRejectBody
    export type SubmissionsRejectMutationError = SubmissionsReject400 | SubmissionsReject403 | SubmissionsReject404 | SubmissionsReject409

    /**
 * @summary Reject a submission
 */
export const useSubmissionsReject = <TError = SubmissionsReject400 | SubmissionsReject403 | SubmissionsReject404 | SubmissionsReject409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submissionsReject>>, TError,{id: string;data: SubmissionsRejectBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submissionsReject>>,
        TError,
        {id: string;data: SubmissionsRejectBody},
        TContext
      > => {

      const mutationOptions = getSubmissionsRejectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Recovers `upload_failed` (enqueue stage) or `scan_failed` rows. Returns 422 BLOB_NOT_AVAILABLE when the original blob was never persisted.
 * @summary Requeue a failed submission
 */
export const submissionsRequeue = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<SubmissionsRequeue200>(
      {url: `/api/submissions/${id}/requeue`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getSubmissionsRequeueMutationOptions = <TError = SubmissionsRequeue403 | SubmissionsRequeue404 | SubmissionsRequeue409 | SubmissionsRequeue422,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submissionsRequeue>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof submissionsRequeue>>, TError,{id: string}, TContext> => {

const mutationKey = ['submissionsRequeue'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submissionsRequeue>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  submissionsRequeue(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmissionsRequeueMutationResult = NonNullable<Awaited<ReturnType<typeof submissionsRequeue>>>
    
    export type SubmissionsRequeueMutationError = SubmissionsRequeue403 | SubmissionsRequeue404 | SubmissionsRequeue409 | SubmissionsRequeue422

    /**
 * @summary Requeue a failed submission
 */
export const useSubmissionsRequeue = <TError = SubmissionsRequeue403 | SubmissionsRequeue404 | SubmissionsRequeue409 | SubmissionsRequeue422,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submissionsRequeue>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof submissionsRequeue>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSubmissionsRequeueMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List teams
 */
export const teamsList = (
    params?: TeamsListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsList200>(
      {url: `/api/teams`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getTeamsListQueryKey = (params?: TeamsListParams,) => {
    return [
    `/api/teams`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTeamsListQueryOptions = <TData = Awaited<ReturnType<typeof teamsList>>, TError = TeamsList400 | TeamsList403>(params?: TeamsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsList>>> = ({ signal }) => teamsList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData> & { queryKey: QueryKey }
}

export type TeamsListQueryResult = NonNullable<Awaited<ReturnType<typeof teamsList>>>
export type TeamsListQueryError = TeamsList400 | TeamsList403


/**
 * @summary List teams
 */

export function useTeamsList<TData = Awaited<ReturnType<typeof teamsList>>, TError = TeamsList400 | TeamsList403>(
 params?: TeamsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTeamsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Async provisioning — enqueues a `provision-team` job and returns 202 with the attempt's source id: freshly inserted, or the same id as the failed attempt for this name that the call reclaimed. At most one open attempt exists per team name. Authorized via `teams:create` OR (the `team-self-provisioning` flag is enabled AND the caller holds a `team_admin` grant).
 * @summary Provision a new team
 */
export const teamsCreate = (
    teamsCreateBody: TeamsCreateBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsCreate202>(
      {url: `/api/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamsCreateBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getTeamsCreateMutationOptions = <TError = TeamsCreate400 | TeamsCreate403 | TeamsCreate404 | TeamsCreate409 | TeamsCreate502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsCreate>>, TError,{data: TeamsCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsCreate>>, TError,{data: TeamsCreateBody}, TContext> => {

const mutationKey = ['teamsCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsCreate>>, {data: TeamsCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  teamsCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof teamsCreate>>>
    export type TeamsCreateMutationBody = TeamsCreateBody
    export type TeamsCreateMutationError = TeamsCreate400 | TeamsCreate403 | TeamsCreate404 | TeamsCreate409 | TeamsCreate502

    /**
 * @summary Provision a new team
 */
export const useTeamsCreate = <TError = TeamsCreate400 | TeamsCreate403 | TeamsCreate404 | TeamsCreate409 | TeamsCreate502,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsCreate>>, TError,{data: TeamsCreateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsCreate>>,
        TError,
        {data: TeamsCreateBody},
        TContext
      > => {

      const mutationOptions = getTeamsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Slug-addressed sibling of `teams_get`, returning the identical row shape. Exists because `/teams/:slug` addresses a team by name; without it the UI resolved the slug by scanning a paginated list page, dropping every team outside the first page. See ADR 0009.
 * @summary Get a single team by name
 */
export const teamsGetByName = (
    name: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsGetByName200>(
      {url: `/api/teams/by-name/${name}`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getTeamsGetByNameQueryKey = (name?: string,) => {
    return [
    `/api/teams/by-name/${name}`
    ] as const;
    }

    
export const getTeamsGetByNameQueryOptions = <TData = Awaited<ReturnType<typeof teamsGetByName>>, TError = TeamsGetByName400 | TeamsGetByName403 | TeamsGetByName404>(name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsGetByName>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsGetByNameQueryKey(name);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsGetByName>>> = ({ signal }) => teamsGetByName(name, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(name), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsGetByName>>, TError, TData> & { queryKey: QueryKey }
}

export type TeamsGetByNameQueryResult = NonNullable<Awaited<ReturnType<typeof teamsGetByName>>>
export type TeamsGetByNameQueryError = TeamsGetByName400 | TeamsGetByName403 | TeamsGetByName404


/**
 * @summary Get a single team by name
 */

export function useTeamsGetByName<TData = Awaited<ReturnType<typeof teamsGetByName>>, TError = TeamsGetByName400 | TeamsGetByName403 | TeamsGetByName404>(
 name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsGetByName>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTeamsGetByNameQueryOptions(name,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all teams matching the filter + sort params as a `text/csv` attachment. Same filter surface as `teams_list` (search, provisionStatus, sort) but without pagination. Capped at 50 000 rows server-side.
 * @summary Export teams as CSV
 */
export const teamsExport = (
    params?: TeamsExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/teams/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getTeamsExportQueryKey = (params?: TeamsExportParams,) => {
    return [
    `/api/teams/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTeamsExportQueryOptions = <TData = Awaited<ReturnType<typeof teamsExport>>, TError = TeamsExport400 | TeamsExport403>(params?: TeamsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsExport>>> = ({ signal }) => teamsExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsExport>>, TError, TData> & { queryKey: QueryKey }
}

export type TeamsExportQueryResult = NonNullable<Awaited<ReturnType<typeof teamsExport>>>
export type TeamsExportQueryError = TeamsExport400 | TeamsExport403


/**
 * @summary Export teams as CSV
 */

export function useTeamsExport<TData = Awaited<ReturnType<typeof teamsExport>>, TError = TeamsExport400 | TeamsExport403>(
 params?: TeamsExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTeamsExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Super-admin only. Soft-deletes the team and flips its `plugin_sources` row to `status=failed`. ADO content is preserved.
 * @summary Soft-delete a team
 */
export const teamsDelete = (
    id: string,
 ) => {
      
      
      return mutator<void>(
      {url: `/api/teams/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getTeamsDeleteMutationOptions = <TError = TeamsDelete403 | TeamsDelete404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsDelete>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['teamsDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  teamsDelete(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof teamsDelete>>>
    
    export type TeamsDeleteMutationError = TeamsDelete403 | TeamsDelete404

    /**
 * @summary Soft-delete a team
 */
export const useTeamsDelete = <TError = TeamsDelete403 | TeamsDelete404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsDelete>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTeamsDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Single-resource fetch — same row shape as the list.
 * @summary Get a single team
 */
export const teamsGet = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsGet200>(
      {url: `/api/teams/${id}`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getTeamsGetQueryKey = (id?: string,) => {
    return [
    `/api/teams/${id}`
    ] as const;
    }

    
export const getTeamsGetQueryOptions = <TData = Awaited<ReturnType<typeof teamsGet>>, TError = TeamsGet400 | TeamsGet403 | TeamsGet404>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsGet>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsGet>>> = ({ signal }) => teamsGet(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsGet>>, TError, TData> & { queryKey: QueryKey }
}

export type TeamsGetQueryResult = NonNullable<Awaited<ReturnType<typeof teamsGet>>>
export type TeamsGetQueryError = TeamsGet400 | TeamsGet403 | TeamsGet404


/**
 * @summary Get a single team
 */

export function useTeamsGet<TData = Awaited<ReturnType<typeof teamsGet>>, TError = TeamsGet400 | TeamsGet403 | TeamsGet404>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsGet>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTeamsGetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Team-scoped: a team_admin may patch only their own team; marketplace_admin / super_admin pass globally.
 * @summary Edit a team
 */
export const teamsUpdate = (
    id: string,
    teamsUpdateBody: TeamsUpdateBody,
 ) => {
      
      
      return mutator<TeamsUpdate200>(
      {url: `/api/teams/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: teamsUpdateBody
    },
      );
    }
  


export const getTeamsUpdateMutationOptions = <TError = TeamsUpdate400 | TeamsUpdate403 | TeamsUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError,{id: string;data: TeamsUpdateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError,{id: string;data: TeamsUpdateBody}, TContext> => {

const mutationKey = ['teamsUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsUpdate>>, {id: string;data: TeamsUpdateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  teamsUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof teamsUpdate>>>
    export type TeamsUpdateMutationBody = TeamsUpdateBody
    export type TeamsUpdateMutationError = TeamsUpdate400 | TeamsUpdate403 | TeamsUpdate404

    /**
 * @summary Edit a team
 */
export const useTeamsUpdate = <TError = TeamsUpdate400 | TeamsUpdate403 | TeamsUpdate404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsUpdate>>, TError,{id: string;data: TeamsUpdateBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsUpdate>>,
        TError,
        {id: string;data: TeamsUpdateBody},
        TContext
      > => {

      const mutationOptions = getTeamsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns the active `team_admin` grant rows for a team. The grant row carries only ids + `createdAt`; UI joins user display fields client-side via `GET /api/users` (which requires `users:view`).
 * @summary List team admin grants
 */
export const teamsListAdmins = (
    id: string,
    params?: TeamsListAdminsParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsListAdmins200>(
      {url: `/api/teams/${id}/admins`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getTeamsListAdminsQueryKey = (id?: string,
    params?: TeamsListAdminsParams,) => {
    return [
    `/api/teams/${id}/admins`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTeamsListAdminsQueryOptions = <TData = Awaited<ReturnType<typeof teamsListAdmins>>, TError = TeamsListAdmins400 | TeamsListAdmins403 | TeamsListAdmins404>(id: string,
    params?: TeamsListAdminsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsListAdmins>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsListAdminsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsListAdmins>>> = ({ signal }) => teamsListAdmins(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsListAdmins>>, TError, TData> & { queryKey: QueryKey }
}

export type TeamsListAdminsQueryResult = NonNullable<Awaited<ReturnType<typeof teamsListAdmins>>>
export type TeamsListAdminsQueryError = TeamsListAdmins400 | TeamsListAdmins403 | TeamsListAdmins404


/**
 * @summary List team admin grants
 */

export function useTeamsListAdmins<TData = Awaited<ReturnType<typeof teamsListAdmins>>, TError = TeamsListAdmins400 | TeamsListAdmins403 | TeamsListAdmins404>(
 id: string,
    params?: TeamsListAdminsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsListAdmins>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTeamsListAdminsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Idempotent on existing non-deleted grants — returns 201 on a fresh insert and 200 on an idempotent re-grant.
 * @summary Grant team_admin to a user
 */
export const teamsAddAdmin = (
    id: string,
    teamsAddAdminBody: TeamsAddAdminBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsAddAdmin200 | TeamsAddAdmin201>(
      {url: `/api/teams/${id}/admins`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamsAddAdminBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getTeamsAddAdminMutationOptions = <TError = TeamsAddAdmin400 | TeamsAddAdmin403 | TeamsAddAdmin404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsAddAdmin>>, TError,{id: string;data: TeamsAddAdminBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsAddAdmin>>, TError,{id: string;data: TeamsAddAdminBody}, TContext> => {

const mutationKey = ['teamsAddAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsAddAdmin>>, {id: string;data: TeamsAddAdminBody}> = (props) => {
          const {id,data} = props ?? {};

          return  teamsAddAdmin(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsAddAdminMutationResult = NonNullable<Awaited<ReturnType<typeof teamsAddAdmin>>>
    export type TeamsAddAdminMutationBody = TeamsAddAdminBody
    export type TeamsAddAdminMutationError = TeamsAddAdmin400 | TeamsAddAdmin403 | TeamsAddAdmin404

    /**
 * @summary Grant team_admin to a user
 */
export const useTeamsAddAdmin = <TError = TeamsAddAdmin400 | TeamsAddAdmin403 | TeamsAddAdmin404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsAddAdmin>>, TError,{id: string;data: TeamsAddAdminBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsAddAdmin>>,
        TError,
        {id: string;data: TeamsAddAdminBody},
        TContext
      > => {

      const mutationOptions = getTeamsAddAdminMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Soft-revokes the grant. The service-layer last-admin guard prevents the team from becoming admin-less (409 `LAST_ADMIN`).
 * @summary Revoke team_admin from a user
 */
export const teamsRemoveAdmin = (
    id: string,
    userId: string,
 ) => {
      
      
      return mutator<void>(
      {url: `/api/teams/${id}/admins/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getTeamsRemoveAdminMutationOptions = <TError = TeamsRemoveAdmin403 | TeamsRemoveAdmin404 | TeamsRemoveAdmin409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveAdmin>>, TError,{id: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveAdmin>>, TError,{id: string;userId: string}, TContext> => {

const mutationKey = ['teamsRemoveAdmin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsRemoveAdmin>>, {id: string;userId: string}> = (props) => {
          const {id,userId} = props ?? {};

          return  teamsRemoveAdmin(id,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsRemoveAdminMutationResult = NonNullable<Awaited<ReturnType<typeof teamsRemoveAdmin>>>
    
    export type TeamsRemoveAdminMutationError = TeamsRemoveAdmin403 | TeamsRemoveAdmin404 | TeamsRemoveAdmin409

    /**
 * @summary Revoke team_admin from a user
 */
export const useTeamsRemoveAdmin = <TError = TeamsRemoveAdmin403 | TeamsRemoveAdmin404 | TeamsRemoveAdmin409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveAdmin>>, TError,{id: string;userId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsRemoveAdmin>>,
        TError,
        {id: string;userId: string},
        TContext
      > => {

      const mutationOptions = getTeamsRemoveAdminMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns the active member association rows (`team_associations` with `kind='member'`) for a team. Members are a plain, non-RBAC, non-ADO tier — the row carries ids + `createdAt` + embedded `displayName`/`email`, but no `adoSyncPending` (members are never mirrored to ADO).
 * @summary List team members
 */
export const teamsListMembers = (
    id: string,
    params?: TeamsListMembersParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsListMembers200>(
      {url: `/api/teams/${id}/members`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getTeamsListMembersQueryKey = (id?: string,
    params?: TeamsListMembersParams,) => {
    return [
    `/api/teams/${id}/members`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTeamsListMembersQueryOptions = <TData = Awaited<ReturnType<typeof teamsListMembers>>, TError = TeamsListMembers400 | TeamsListMembers403 | TeamsListMembers404>(id: string,
    params?: TeamsListMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsListMembers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsListMembersQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsListMembers>>> = ({ signal }) => teamsListMembers(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsListMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type TeamsListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof teamsListMembers>>>
export type TeamsListMembersQueryError = TeamsListMembers400 | TeamsListMembers403 | TeamsListMembers404


/**
 * @summary List team members
 */

export function useTeamsListMembers<TData = Awaited<ReturnType<typeof teamsListMembers>>, TError = TeamsListMembers400 | TeamsListMembers403 | TeamsListMembers404>(
 id: string,
    params?: TeamsListMembersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsListMembers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTeamsListMembersQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Adds a marketplace user as a plain team member (no permissions, no ADO sync). Idempotent on existing non-deleted rows — 201 on a fresh insert, 200 on an idempotent re-add. Gated by `teams:manage_admins` (no dedicated member permission).
 * @summary Add a member to a team
 */
export const teamsAddMember = (
    id: string,
    teamsAddMemberBody: TeamsAddMemberBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsAddMember200 | TeamsAddMember201>(
      {url: `/api/teams/${id}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamsAddMemberBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getTeamsAddMemberMutationOptions = <TError = TeamsAddMember400 | TeamsAddMember403 | TeamsAddMember404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsAddMember>>, TError,{id: string;data: TeamsAddMemberBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsAddMember>>, TError,{id: string;data: TeamsAddMemberBody}, TContext> => {

const mutationKey = ['teamsAddMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsAddMember>>, {id: string;data: TeamsAddMemberBody}> = (props) => {
          const {id,data} = props ?? {};

          return  teamsAddMember(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsAddMemberMutationResult = NonNullable<Awaited<ReturnType<typeof teamsAddMember>>>
    export type TeamsAddMemberMutationBody = TeamsAddMemberBody
    export type TeamsAddMemberMutationError = TeamsAddMember400 | TeamsAddMember403 | TeamsAddMember404

    /**
 * @summary Add a member to a team
 */
export const useTeamsAddMember = <TError = TeamsAddMember400 | TeamsAddMember403 | TeamsAddMember404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsAddMember>>, TError,{id: string;data: TeamsAddMemberBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsAddMember>>,
        TError,
        {id: string;data: TeamsAddMemberBody},
        TContext
      > => {

      const mutationOptions = getTeamsAddMemberMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Soft-removes the member association. No last-member guard — a team with zero members is a valid state.
 * @summary Remove a member from a team
 */
export const teamsRemoveMember = (
    id: string,
    userId: string,
 ) => {
      
      
      return mutator<void>(
      {url: `/api/teams/${id}/members/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getTeamsRemoveMemberMutationOptions = <TError = TeamsRemoveMember403 | TeamsRemoveMember404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveMember>>, TError,{id: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveMember>>, TError,{id: string;userId: string}, TContext> => {

const mutationKey = ['teamsRemoveMember'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsRemoveMember>>, {id: string;userId: string}> = (props) => {
          const {id,userId} = props ?? {};

          return  teamsRemoveMember(id,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsRemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof teamsRemoveMember>>>
    
    export type TeamsRemoveMemberMutationError = TeamsRemoveMember403 | TeamsRemoveMember404

    /**
 * @summary Remove a member from a team
 */
export const useTeamsRemoveMember = <TError = TeamsRemoveMember403 | TeamsRemoveMember404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveMember>>, TError,{id: string;userId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsRemoveMember>>,
        TError,
        {id: string;userId: string},
        TContext
      > => {

      const mutationOptions = getTeamsRemoveMemberMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Returns the active `team_reviewers` association rows for a team. The row carries only ids + `createdAt`; UI joins user display fields client-side via `GET /api/users`.
 * @summary List team reviewers
 */
export const teamsListReviewers = (
    id: string,
    params?: TeamsListReviewersParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsListReviewers200>(
      {url: `/api/teams/${id}/reviewers`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getTeamsListReviewersQueryKey = (id?: string,
    params?: TeamsListReviewersParams,) => {
    return [
    `/api/teams/${id}/reviewers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getTeamsListReviewersQueryOptions = <TData = Awaited<ReturnType<typeof teamsListReviewers>>, TError = TeamsListReviewers400 | TeamsListReviewers403 | TeamsListReviewers404>(id: string,
    params?: TeamsListReviewersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsListReviewers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeamsListReviewersQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teamsListReviewers>>> = ({ signal }) => teamsListReviewers(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teamsListReviewers>>, TError, TData> & { queryKey: QueryKey }
}

export type TeamsListReviewersQueryResult = NonNullable<Awaited<ReturnType<typeof teamsListReviewers>>>
export type TeamsListReviewersQueryError = TeamsListReviewers400 | TeamsListReviewers403 | TeamsListReviewers404


/**
 * @summary List team reviewers
 */

export function useTeamsListReviewers<TData = Awaited<ReturnType<typeof teamsListReviewers>>, TError = TeamsListReviewers400 | TeamsListReviewers403 | TeamsListReviewers404>(
 id: string,
    params?: TeamsListReviewersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof teamsListReviewers>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTeamsListReviewersQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Adds a marketplace user as a PR reviewer. Idempotent on existing non-deleted rows — 201 on a fresh insert, 200 on an idempotent re-add.
 * @summary Add a reviewer to a team
 */
export const teamsAddReviewer = (
    id: string,
    teamsAddReviewerBody: TeamsAddReviewerBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<TeamsAddReviewer200 | TeamsAddReviewer201>(
      {url: `/api/teams/${id}/reviewers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamsAddReviewerBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getTeamsAddReviewerMutationOptions = <TError = TeamsAddReviewer400 | TeamsAddReviewer403 | TeamsAddReviewer404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsAddReviewer>>, TError,{id: string;data: TeamsAddReviewerBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsAddReviewer>>, TError,{id: string;data: TeamsAddReviewerBody}, TContext> => {

const mutationKey = ['teamsAddReviewer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsAddReviewer>>, {id: string;data: TeamsAddReviewerBody}> = (props) => {
          const {id,data} = props ?? {};

          return  teamsAddReviewer(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsAddReviewerMutationResult = NonNullable<Awaited<ReturnType<typeof teamsAddReviewer>>>
    export type TeamsAddReviewerMutationBody = TeamsAddReviewerBody
    export type TeamsAddReviewerMutationError = TeamsAddReviewer400 | TeamsAddReviewer403 | TeamsAddReviewer404

    /**
 * @summary Add a reviewer to a team
 */
export const useTeamsAddReviewer = <TError = TeamsAddReviewer400 | TeamsAddReviewer403 | TeamsAddReviewer404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsAddReviewer>>, TError,{id: string;data: TeamsAddReviewerBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsAddReviewer>>,
        TError,
        {id: string;data: TeamsAddReviewerBody},
        TContext
      > => {

      const mutationOptions = getTeamsAddReviewerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Soft-removes the reviewer association. No last-reviewer guard — an empty Reviewers team is a valid (PR-gating) state.
 * @summary Remove a reviewer from a team
 */
export const teamsRemoveReviewer = (
    id: string,
    userId: string,
 ) => {
      
      
      return mutator<void>(
      {url: `/api/teams/${id}/reviewers/${userId}`, method: 'DELETE'
    },
      );
    }
  


export const getTeamsRemoveReviewerMutationOptions = <TError = TeamsRemoveReviewer403 | TeamsRemoveReviewer404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveReviewer>>, TError,{id: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveReviewer>>, TError,{id: string;userId: string}, TContext> => {

const mutationKey = ['teamsRemoveReviewer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof teamsRemoveReviewer>>, {id: string;userId: string}> = (props) => {
          const {id,userId} = props ?? {};

          return  teamsRemoveReviewer(id,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TeamsRemoveReviewerMutationResult = NonNullable<Awaited<ReturnType<typeof teamsRemoveReviewer>>>
    
    export type TeamsRemoveReviewerMutationError = TeamsRemoveReviewer403 | TeamsRemoveReviewer404

    /**
 * @summary Remove a reviewer from a team
 */
export const useTeamsRemoveReviewer = <TError = TeamsRemoveReviewer403 | TeamsRemoveReviewer404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof teamsRemoveReviewer>>, TError,{id: string;userId: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof teamsRemoveReviewer>>,
        TError,
        {id: string;userId: string},
        TContext
      > => {

      const mutationOptions = getTeamsRemoveReviewerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Paginated admin listing of users with their per-team role grants.
 * @summary List users
 */
export const usersList = (
    params?: UsersListParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<UsersList200>(
      {url: `/api/users`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getUsersListQueryKey = (params?: UsersListParams,) => {
    return [
    `/api/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUsersListQueryOptions = <TData = Awaited<ReturnType<typeof usersList>>, TError = UsersList400 | UsersList401 | UsersList403>(params?: UsersListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersList>>> = ({ signal }) => usersList(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersListQueryResult = NonNullable<Awaited<ReturnType<typeof usersList>>>
export type UsersListQueryError = UsersList400 | UsersList401 | UsersList403


/**
 * @summary List users
 */

export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = UsersList400 | UsersList401 | UsersList403>(
 params?: UsersListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUsersListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Exports all users matching the filter + sort params as a text/csv attachment. Same filter surface as users_list (search, roleName, isTrusted, teamId, sort) but without pagination. Capped at 50 000 rows server-side.
 * @summary Export users as CSV
 */
export const usersExport = (
    params?: UsersExportParams,
 signal?: AbortSignal
) => {
      
      
      return mutator<string>(
      {url: `/api/users/export`, method: 'GET',
        params, ...(signal ? { signal }: {})
    },
      );
    }
  



export const getUsersExportQueryKey = (params?: UsersExportParams,) => {
    return [
    `/api/users/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUsersExportQueryOptions = <TData = Awaited<ReturnType<typeof usersExport>>, TError = UsersExport400 | UsersExport403>(params?: UsersExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersExport>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersExport>>> = ({ signal }) => usersExport(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersExport>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersExportQueryResult = NonNullable<Awaited<ReturnType<typeof usersExport>>>
export type UsersExportQueryError = UsersExport400 | UsersExport403


/**
 * @summary Export users as CSV
 */

export function useUsersExport<TData = Awaited<ReturnType<typeof usersExport>>, TError = UsersExport400 | UsersExport403>(
 params?: UsersExportParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersExport>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUsersExportQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Single-resource fetch — same row shape as the list.
 * @summary Get a single user
 */
export const usersGet = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<UsersGet200>(
      {url: `/api/users/${id}`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getUsersGetQueryKey = (id?: string,) => {
    return [
    `/api/users/${id}`
    ] as const;
    }

    
export const getUsersGetQueryOptions = <TData = Awaited<ReturnType<typeof usersGet>>, TError = UsersGet400 | UsersGet403 | UsersGet404>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGet>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGet>>> = ({ signal }) => usersGet(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersGet>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersGetQueryResult = NonNullable<Awaited<ReturnType<typeof usersGet>>>
export type UsersGetQueryError = UsersGet400 | UsersGet403 | UsersGet404


/**
 * @summary Get a single user
 */

export function useUsersGet<TData = Awaited<ReturnType<typeof usersGet>>, TError = UsersGet400 | UsersGet403 | UsersGet404>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGet>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUsersGetQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Manual override of a user's ADO origin id (Graph object id), used when resolution is ambiguous or not_found. Rejects an oid not present in the directory (Entra) or already linked to another user.
 * @summary Manually set a user's ADO origin id
 */
export const usersOverrideAdoIdentity = (
    id: string,
    usersOverrideAdoIdentityBody: UsersOverrideAdoIdentityBody,
 ) => {
      
      
      return mutator<UsersOverrideAdoIdentity200>(
      {url: `/api/users/${id}/ado-identity`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: usersOverrideAdoIdentityBody
    },
      );
    }
  


export const getUsersOverrideAdoIdentityMutationOptions = <TError = UsersOverrideAdoIdentity400 | UsersOverrideAdoIdentity403 | UsersOverrideAdoIdentity404 | UsersOverrideAdoIdentity409 | UsersOverrideAdoIdentity422 | UsersOverrideAdoIdentity503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersOverrideAdoIdentity>>, TError,{id: string;data: UsersOverrideAdoIdentityBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersOverrideAdoIdentity>>, TError,{id: string;data: UsersOverrideAdoIdentityBody}, TContext> => {

const mutationKey = ['usersOverrideAdoIdentity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersOverrideAdoIdentity>>, {id: string;data: UsersOverrideAdoIdentityBody}> = (props) => {
          const {id,data} = props ?? {};

          return  usersOverrideAdoIdentity(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersOverrideAdoIdentityMutationResult = NonNullable<Awaited<ReturnType<typeof usersOverrideAdoIdentity>>>
    export type UsersOverrideAdoIdentityMutationBody = UsersOverrideAdoIdentityBody
    export type UsersOverrideAdoIdentityMutationError = UsersOverrideAdoIdentity400 | UsersOverrideAdoIdentity403 | UsersOverrideAdoIdentity404 | UsersOverrideAdoIdentity409 | UsersOverrideAdoIdentity422 | UsersOverrideAdoIdentity503

    /**
 * @summary Manually set a user's ADO origin id
 */
export const useUsersOverrideAdoIdentity = <TError = UsersOverrideAdoIdentity400 | UsersOverrideAdoIdentity403 | UsersOverrideAdoIdentity404 | UsersOverrideAdoIdentity409 | UsersOverrideAdoIdentity422 | UsersOverrideAdoIdentity503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersOverrideAdoIdentity>>, TError,{id: string;data: UsersOverrideAdoIdentityBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof usersOverrideAdoIdentity>>,
        TError,
        {id: string;data: UsersOverrideAdoIdentityBody},
        TContext
      > => {

      const mutationOptions = getUsersOverrideAdoIdentityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Re-runs `ensureOriginId` against Microsoft Graph for the user's email. On `ambiguous`, `candidates` lists the matching Graph users so an admin can pick the correct one via the override endpoint.
 * @summary Re-run resolution of a user's ADO identity
 */
export const usersResolveAdoIdentity = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<UsersResolveAdoIdentity200>(
      {url: `/api/users/${id}/ado-identity/resolve`, method: 'POST', ...(signal ? { signal }: {})
    },
      );
    }
  


export const getUsersResolveAdoIdentityMutationOptions = <TError = UsersResolveAdoIdentity400 | UsersResolveAdoIdentity403 | UsersResolveAdoIdentity404 | UsersResolveAdoIdentity503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersResolveAdoIdentity>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersResolveAdoIdentity>>, TError,{id: string}, TContext> => {

const mutationKey = ['usersResolveAdoIdentity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersResolveAdoIdentity>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  usersResolveAdoIdentity(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersResolveAdoIdentityMutationResult = NonNullable<Awaited<ReturnType<typeof usersResolveAdoIdentity>>>
    
    export type UsersResolveAdoIdentityMutationError = UsersResolveAdoIdentity400 | UsersResolveAdoIdentity403 | UsersResolveAdoIdentity404 | UsersResolveAdoIdentity503

    /**
 * @summary Re-run resolution of a user's ADO identity
 */
export const useUsersResolveAdoIdentity = <TError = UsersResolveAdoIdentity400 | UsersResolveAdoIdentity403 | UsersResolveAdoIdentity404 | UsersResolveAdoIdentity503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersResolveAdoIdentity>>, TError,{id: string}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof usersResolveAdoIdentity>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getUsersResolveAdoIdentityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Applies an atomic add/remove delta to a user's role grants. Self-role-edit is rejected with 403 SELF_EDIT_FORBIDDEN. The 409 LAST_SUPER_ADMIN guard prevents reducing the global super_admin pool below two.
 * @summary Apply role-grant deltas to a user
 */
export const usersUpdateRoles = (
    id: string,
    usersUpdateRolesBody: UsersUpdateRolesBody,
 ) => {
      
      
      return mutator<UsersUpdateRoles200>(
      {url: `/api/users/${id}/roles`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: usersUpdateRolesBody
    },
      );
    }
  


export const getUsersUpdateRolesMutationOptions = <TError = UsersUpdateRoles400 | UsersUpdateRoles403 | UsersUpdateRoles409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateRoles>>, TError,{id: string;data: UsersUpdateRolesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersUpdateRoles>>, TError,{id: string;data: UsersUpdateRolesBody}, TContext> => {

const mutationKey = ['usersUpdateRoles'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateRoles>>, {id: string;data: UsersUpdateRolesBody}> = (props) => {
          const {id,data} = props ?? {};

          return  usersUpdateRoles(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersUpdateRolesMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateRoles>>>
    export type UsersUpdateRolesMutationBody = UsersUpdateRolesBody
    export type UsersUpdateRolesMutationError = UsersUpdateRoles400 | UsersUpdateRoles403 | UsersUpdateRoles409

    /**
 * @summary Apply role-grant deltas to a user
 */
export const useUsersUpdateRoles = <TError = UsersUpdateRoles400 | UsersUpdateRoles403 | UsersUpdateRoles409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateRoles>>, TError,{id: string;data: UsersUpdateRolesBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof usersUpdateRoles>>,
        TError,
        {id: string;data: UsersUpdateRolesBody},
        TContext
      > => {

      const mutationOptions = getUsersUpdateRolesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Per-team admin/reviewer state for the user, plus the ADO-org membership probe result. Powers the Teams tab of the admin user detail sheet.
 * @summary List a user's team admin/reviewer memberships
 */
export const usersGetTeamRoles = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return mutator<UsersGetTeamRoles200>(
      {url: `/api/users/${id}/team-roles`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getUsersGetTeamRolesQueryKey = (id?: string,) => {
    return [
    `/api/users/${id}/team-roles`
    ] as const;
    }

    
export const getUsersGetTeamRolesQueryOptions = <TData = Awaited<ReturnType<typeof usersGetTeamRoles>>, TError = UsersGetTeamRoles400 | UsersGetTeamRoles403 | UsersGetTeamRoles404>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetTeamRoles>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersGetTeamRolesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersGetTeamRoles>>> = ({ signal }) => usersGetTeamRoles(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersGetTeamRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type UsersGetTeamRolesQueryResult = NonNullable<Awaited<ReturnType<typeof usersGetTeamRoles>>>
export type UsersGetTeamRolesQueryError = UsersGetTeamRoles400 | UsersGetTeamRoles403 | UsersGetTeamRoles404


/**
 * @summary List a user's team admin/reviewer memberships
 */

export function useUsersGetTeamRoles<TData = Awaited<ReturnType<typeof usersGetTeamRoles>>, TError = UsersGetTeamRoles400 | UsersGetTeamRoles403 | UsersGetTeamRoles404>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof usersGetTeamRoles>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUsersGetTeamRolesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Super-admin only. Auto-approves submissions from a trusted user.
 * @summary Toggle a user's `isTrusted` flag
 */
export const usersUpdateTrusted = (
    id: string,
    usersUpdateTrustedBody: UsersUpdateTrustedBody,
 ) => {
      
      
      return mutator<UsersUpdateTrusted200>(
      {url: `/api/users/${id}/trusted`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: usersUpdateTrustedBody
    },
      );
    }
  


export const getUsersUpdateTrustedMutationOptions = <TError = UsersUpdateTrusted400 | UsersUpdateTrusted403 | UsersUpdateTrusted404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateTrusted>>, TError,{id: string;data: UsersUpdateTrustedBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof usersUpdateTrusted>>, TError,{id: string;data: UsersUpdateTrustedBody}, TContext> => {

const mutationKey = ['usersUpdateTrusted'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdateTrusted>>, {id: string;data: UsersUpdateTrustedBody}> = (props) => {
          const {id,data} = props ?? {};

          return  usersUpdateTrusted(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersUpdateTrustedMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdateTrusted>>>
    export type UsersUpdateTrustedMutationBody = UsersUpdateTrustedBody
    export type UsersUpdateTrustedMutationError = UsersUpdateTrusted400 | UsersUpdateTrusted403 | UsersUpdateTrusted404

    /**
 * @summary Toggle a user's `isTrusted` flag
 */
export const useUsersUpdateTrusted = <TError = UsersUpdateTrusted400 | UsersUpdateTrusted403 | UsersUpdateTrusted404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdateTrusted>>, TError,{id: string;data: UsersUpdateTrustedBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof usersUpdateTrusted>>,
        TError,
        {id: string;data: UsersUpdateTrustedBody},
        TContext
      > => {

      const mutationOptions = getUsersUpdateTrustedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Unconditional liveness probe consumed by ACA startup checks. Returns 200 as long as the event loop is responsive.
 * @summary Liveness probe
 */
export const healthLive = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<HealthLive200>(
      {url: `/health/live`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getHealthLiveQueryKey = () => {
    return [
    `/health/live`
    ] as const;
    }

    
export const getHealthLiveQueryOptions = <TData = Awaited<ReturnType<typeof healthLive>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthLiveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthLive>>> = ({ signal }) => healthLive(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthLiveQueryResult = NonNullable<Awaited<ReturnType<typeof healthLive>>>
export type HealthLiveQueryError = unknown


/**
 * @summary Liveness probe
 */

export function useHealthLive<TData = Awaited<ReturnType<typeof healthLive>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthLive>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthLiveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Reports per-dependency readiness (DB, Redis, App Insights). Returns 503 with the same body shape when any dependency is unhealthy.
 * @summary Readiness probe
 */
export const healthReady = (
    
 signal?: AbortSignal
) => {
      
      
      return mutator<HealthReady200>(
      {url: `/health/ready`, method: 'GET', ...(signal ? { signal }: {})
    },
      );
    }
  



export const getHealthReadyQueryKey = () => {
    return [
    `/health/ready`
    ] as const;
    }

    
export const getHealthReadyQueryOptions = <TData = Awaited<ReturnType<typeof healthReady>>, TError = HealthReady503>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthReadyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthReady>>> = ({ signal }) => healthReady(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthReadyQueryResult = NonNullable<Awaited<ReturnType<typeof healthReady>>>
export type HealthReadyQueryError = HealthReady503


/**
 * @summary Readiness probe
 */

export function useHealthReady<TData = Awaited<ReturnType<typeof healthReady>>, TError = HealthReady503>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthReady>>, TError, TData>, }
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthReadyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Receives ADO `git.push` service-hook payloads. HTTP Basic auth: `username = ado_repo_id`, `password = webhook_secret` (constant-time compared against the active or pending value). Enqueues a `sync-repo` job with `jobId = ${sourceId}--${headSha}` for idempotent re-execution.
 * @summary ADO push webhook receiver
 */
export const webhooksAdoPush = (
    webhooksAdoPushBody: WebhooksAdoPushBody,
 signal?: AbortSignal
) => {
      
      
      return mutator<WebhooksAdoPush200>(
      {url: `/webhooks/ado`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: webhooksAdoPushBody, ...(signal ? { signal }: {})
    },
      );
    }
  


export const getWebhooksAdoPushMutationOptions = <TError = WebhooksAdoPush400 | WebhooksAdoPush401 | WebhooksAdoPush404 | WebhooksAdoPush503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof webhooksAdoPush>>, TError,{data: WebhooksAdoPushBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof webhooksAdoPush>>, TError,{data: WebhooksAdoPushBody}, TContext> => {

const mutationKey = ['webhooksAdoPush'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof webhooksAdoPush>>, {data: WebhooksAdoPushBody}> = (props) => {
          const {data} = props ?? {};

          return  webhooksAdoPush(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebhooksAdoPushMutationResult = NonNullable<Awaited<ReturnType<typeof webhooksAdoPush>>>
    export type WebhooksAdoPushMutationBody = WebhooksAdoPushBody
    export type WebhooksAdoPushMutationError = WebhooksAdoPush400 | WebhooksAdoPush401 | WebhooksAdoPush404 | WebhooksAdoPush503

    /**
 * @summary ADO push webhook receiver
 */
export const useWebhooksAdoPush = <TError = WebhooksAdoPush400 | WebhooksAdoPush401 | WebhooksAdoPush404 | WebhooksAdoPush503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof webhooksAdoPush>>, TError,{data: WebhooksAdoPushBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof webhooksAdoPush>>,
        TError,
        {data: WebhooksAdoPushBody},
        TContext
      > => {

      const mutationOptions = getWebhooksAdoPushMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
